/* NineTwoFive — cart rewards (tiers) behaviour.
   Served as a cacheable asset instead of inline script: inlined it added ~38KB of uncacheable
   HTML to every page, including product pages that never open the cart.
   Its one setting arrives via window.NTF_CART_CONFIG, set inline just before this loads. */
(function(){
  if (window.__crInit) return; window.__crInit = true;

  function fmt(cents){
    // Always format like the shop's own money_format (comma decimal), regardless of the
    // customer's selected language — server-rendered prices elsewhere on the page don't
    // follow the language toggle either, so this keeps the popup visually consistent.
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    /* No ",00" on a round amount (Kai, 24 Sept) — the same rule Liquid now applies through
       money_without_trailing_zeros, so a price written from here matches the server-rendered one
       beside it. The test is on the actual cents, not on the currency: a zero-decimal currency like
       JPY has nothing to strip and a genuinely fractional amount keeps both digits. */
    var round = (cents % 100) === 0;
    try {
      return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
        minimumFractionDigits: round ? 0 : 2, maximumFractionDigits: round ? 0 : 2 }).format(cents/100);
    }
    catch(e){ return (round ? String(cents/100) : (cents/100).toFixed(2).replace('.', ',')) + ' ' + cur; }
  }
  /* ---- Copy ------------------------------------------------------------------------------------
     Every user-visible string this file writes comes from snippets/ntf-i18n.liquid, read at the
     moment it is used. Weglot translates the HTML the server delivered; a string written from here
     is a node it has never seen and would stay English in every language (engineering rule 1).
     This is a static asset, so it cannot hold Liquid — hence the block, and hence a lookup rather
     than a literal. The third argument is the English the block carries, so a missing key or a
     snippet that failed to render degrades to today's text instead of an empty label. */
  function T(key, vars, fallback){
    return (typeof window.NTF_T === 'function') ? window.NTF_T(key, vars, fallback) : (fallback || '');
  }
  /* Same, for a sentence whose values carry markup — the amount in "Spend <b>€77,00</b> more for
     X" is bold. The values are escaped by the CALLER before they go in, because only the caller
     knows which of them came from a metaobject. */
  function TH(key, vars, fallback){
    return (typeof window.NTF_TH === 'function') ? window.NTF_TH(key, vars, fallback) : (fallback || '');
  }
  /* "€ 77,00 to go" is one sentence with a number in it, not a number with a suffix: Dutch puts
     the amount somewhere else ("nog € 77,00"). */
  function toGo(cents){ return T('to-go', { amount: fmt(cents) }, fmt(cents) + ' to go'); }
  /* ---- The free-shipping threshold, in the money the customer is actually charged in -----------
     Every OTHER tier is a Money metafield, so Shopify converts it per market; the shipping tier is
     a number compiled out of the delivery profile, and it was printed bare under whatever symbol
     the visitor happened to be browsing in. A Swedish shopper was promised free shipping at
     "100 kr" against a real threshold near 1,133 kr — a promise checkout would not keep.

     Shopify.currency.rate converts the SHOP currency into the one on screen. The profile writes
     most zones' conditions in the shop currency and converts the cart before testing them; GB and
     US are written in their own money, and those are only ever seen from the GB/US markets, where
     rate is 1 and no conversion is wanted. So: convert exactly when the currencies differ AND a
     rate is in play. The result is rounded UP, never down, so the figure on screen is never lower
     than the one enforced at checkout. */
  function ntfCur(){ return (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR'; }
  function ntfRate(){
    var r = parseFloat(window.Shopify && Shopify.currency && Shopify.currency.rate);
    return (isFinite(r) && r > 0) ? r : 1;
  }
  // A threshold is a marketing number, not a price: 1 133 kr is stated as 1 150 kr.
  function ntfTidy(v){
    var step = v < 100 ? 5 : v < 1000 ? 10 : v < 5000 ? 50 : v < 50000 ? 500 : 5000;
    return Math.ceil(v / step) * step;
  }
  /* One threshold amount, in the money the customer is charged in. `from` is the currency the
     delivery profile wrote the condition in. Returns CENTS, or null when there is nothing to
     convert.

     Exported because the delivery sheet needs the SAME answer for a threshold that is not the
     zone's headline one — a zone gives Priority free at 100 and Express free at 300, and the
     sheet prints a card for each. Doing that arithmetic a second time in the sheet is how the two
     surfaces end up disagreeing, so there is one implementation and shipThresholdCents() is now a
     caller of it like everyone else. */
  function ntfShipConvert(amount, from){
    if (amount == null || !isFinite(amount)) return null;
    from = from || 'EUR';
    var rate = ntfRate();
    if (from === ntfCur() || rate === 1) return Math.round(amount * 100);
    return Math.round(ntfTidy(amount * rate) * 100);
  }
  window.NTF_SHIP_CONVERT = ntfShipConvert;
  // Cents in the active currency, or null when there is no zone to read.
  function shipThresholdCents(){
    /* The DESTINATION's threshold first. ntf-ship-sheet.js publishes the zone for whichever
       country is currently picked in the delivery sheet; window.NTF_SHIP below is only ever the
       market the customer is BROWSING in, because Liquid renders it once and cannot know what
       they pick afterwards. Reading only that is why the ladder could say "free shipping" while
       the sheet three lines down said "spend EUR 1 more" (Kai, 23 Sept). */
    var st = window.NTF_SHIP_STATE;
    if (st && st.zone && st.zone.free_from != null)
      return ntfShipConvert(st.zone.free_from, st.zone.c || 'EUR');
    /* NTF_SHIP wraps the compiled payload one level down — NTF_SHIP.zone is the OBJECT, whose own
       .zone is the zone's name. Unwrapped defensively so either shape works. */
    var z = window.NTF_SHIP;
    if (z && z.zone && typeof z.zone === 'object') z = z.zone;
    if (!z || z.free_from == null) return null;
    return ntfShipConvert(z.free_from, z.c || 'EUR');
  }
  window.NTF_SHIP_THRESHOLD = shipThresholdCents;
  /* The announcement bar and the product page print the threshold server-side, where Liquid has no
     access to the market's rate. They render it in the currency the delivery profile holds and mark
     it with data-ntf-ff; this rewrites the text into the customer's own money using the SAME
     conversion the ladder uses, so the bar and the ladder can never state different figures.
     In a market whose currency already matches the condition — every euro market, plus GB and US —
     the text is already right and nothing is touched. */
  function paintFreeFrom(){
    var els = document.querySelectorAll('[data-ntf-ff]');
    if (!els.length) return;
    var cents = shipThresholdCents();
    if (cents == null) return;
    for (var i = 0; i < els.length; i++){
      var el = els[i];
      /* The SERVER's string is kept as the template and only its number is swapped. Formatting the
         amount from scratch with Intl gave "SEK 1.150" and "AU$ 250" on pages whose own prices read
         "1 150 kr" and "$250" — the right money under the wrong badge. Shopify's money format is
         not exposed to JS, but it is already sitting in this element, so it is reused. */
      var tpl = el.getAttribute('data-ntf-ff-tpl');
      if (tpl == null){ tpl = (el.textContent || '').trim(); el.setAttribute('data-ntf-ff-tpl', tpl); }
      var n;
      try { n = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL').format(cents / 100); }
      catch(e){ n = String(Math.round(cents / 100)); }
      /* The first run of digits is the amount; everything else is the currency. Grouping characters
         are included, trailing WHITESPACE is not — it belongs to the currency, and eating it turned
         "100 kr" into "1,150kr". A threshold is never large enough to carry grouping in the server
         template, so leaving spaces out of the class is safe. */
      var next = tpl.replace(/\d[\d.,]*\d|\d/, n);
      if ((el.textContent || '').trim() !== next) el.textContent = next;
    }
  }
  /* For text that arrives after load - an info drawer's page with a {threshold} in it
     (snippets/ntf-info-drawer.liquid) - so it is converted by this code and no other. */
  window.NTF_PAINT_FF = paintFreeFrom;
  /* A shipping FEE printed server-side in the profile's currency (data-ntf-fee, cents; the ring sizer's line,
     snippets/ntf-shipping-sizer-money.liquid). Converted only when the visitor pays in another currency, with the
     same conversion as the thresholds, so it is rounded UP and never lower than checkout. */
  function paintFee(){
    var els = document.querySelectorAll('[data-ntf-fee]');
    for (var i = 0; i < els.length; i++){
      var el = els[i], cents = ntfShipConvert(parseInt(el.getAttribute('data-ntf-fee'), 10) / 100, el.getAttribute('data-ntf-fee-cur'));
      if (cents == null || cents === parseInt(el.getAttribute('data-ntf-fee'), 10)) continue;
      var tpl = el.getAttribute('data-ntf-fee-tpl');
      if (tpl == null){ tpl = (el.textContent || '').trim(); el.setAttribute('data-ntf-fee-tpl', tpl); }
      var n;
      try { n = new Intl.NumberFormat(document.documentElement.lang || 'nl-NL').format(cents / 100); }
      catch(e){ n = String(Math.round(cents / 100)); }
      el.textContent = tpl.replace(/\d[\d.,]*\d|\d/, n);
    }
  }
  /* Applied wherever the ladder is read, so the cart page, the drawer, the product page and the
     popup all get the converted figure from one place. */
  function ntfFixShipTier(arr){
    ntfTierCopy(arr);
    var cents = shipThresholdCents();
    if (cents == null) return arr;
    arr.forEach(function(t){ if (t && t.type === 'shipping') t.th = cents; });
    return arr;
  }
  /* Tier labels and descriptions are CAMPAIGN copy from the metaobject, and they reach this file
     inside a JSON data attribute — which no translation layer can read, so they stayed English in
     every language along with everything else the JS writes. snippets/ntf-i18n.liquid prints the
     same metaobject fields as real text; this swaps them in. Same source, so the two cannot drift.

     The label may carry two wordings separated by a pipe ("Free beaded bracelet|Bracelet") — the
     sentence wording and the chip wording — and both halves are rebuilt so shortLabel() keeps
     working. Anything without a match is left exactly as the JSON had it. */
  function ntfTierCopy(arr){
    if (typeof window.NTF_TIER !== 'function' || !Array.isArray(arr)) return arr;
    arr.forEach(function(t){
      if (!t || !t.label) return;
      var en = String(t.label).split('|')[0].trim();
      var tr = window.NTF_TIER(en);
      if (!tr) return;
      if (tr.full) t.label = tr.short ? (tr.full + '|' + tr.short) : tr.full;
      if (tr.desc) t.desc = tr.desc;
    });
    return arr;
  }

  // Tiers come from the campaign metaobject as JSON (variable count — a campaign can run
  // 1, 2 or 3 tiers). Falls back to the older per-tier data attributes if present.
  function getTiers(row){
    if (row.dataset.tiers){
      try {
        var arr = JSON.parse(row.dataset.tiers);
        if (Array.isArray(arr) && arr.length) return ntfFixShipTier(arr);
      } catch(e){ /* fall through */ }
    }
    var legacy = [];
    for (var i = 1; i <= 3; i++){
      var th = +row.dataset['tier' + i];
      if (th > 0) legacy.push({ th: th, label: row.dataset['offer' + i],
        img: row.dataset['img' + i], desc: row.dataset['txt' + i] });
    }
    return legacy;
  }
  /* Which figure a tier is judged by. `value` on the row is what the customer pays for everything that
     is not a gift AFTER every discount — the basis Shopify's price-based shipping conditions use, so
     the shipping tier compares against it. Every reward tier compares against value + the order-level
     sale (data-order-disc), i.e. the pre-sale figure: Shopify judges the sale's own minimum on it, and
     EasyGift's Function judges its reward rule on it (measured 11 Sept in EUR — €273 list / €245.70
     after: refused; €283 / €254.70: freed), so the tier unlocks exactly when the line would be free. */
  /* Weglot translated URLs while it ran, and a browser that met /cart.js before 21 Sept 2026 may
     still hold its permanent redirect to /nl/wagen.js — which now 404s, so every cart read fails and
     the drawer, the ladder and the recommendations all read an empty cart. Proven in Kai's own
     Chrome on 2026-09-23: /cart.js 404 from cache, 200 with the cache bypassed. A query string
     defeats the cached redirect, and no-store keeps the answer fresh. Harmless once caches expire. */
  function cartJsUrl(){ return '/cart.js?_=' + Date.now(); }
  /* The last cart this file read, whoever read it. The popup names what is in the cart in its
     closing sentence; seeded from here it has the words in the frame it opens, instead of a moment
     later when its own read lands - which made the whole dialog jump up (Kai, 25 Sept, Fix 4). */
  var lastCart = null;
  function rememberCart(c){ if (c && c.items) lastCart = c; return c; }
  function cartTitlesOf(c){
    return ((c && c.items) || []).filter(function(it){ return !isGiftLineItem(it); })
      .map(function(it){ return it.product_title || it.title; });
  }

  var curOrderDisc = 0;
  function vFor(v, t){ return (t && t.type === 'shipping') ? v : v + curOrderDisc; }
  function unlocked(v, t){ return vFor(v, t) >= t.th; }
  function nextIdx(v, TIERS){ for (var i=0;i<TIERS.length;i++){ if(!unlocked(v, TIERS[i])) return i; } return -1; }
  function defaultView(v, TIERS){ var n = nextIdx(v, TIERS); return n===-1 ? TIERS.length-1 : n; }
  function segPct(i, TIERS, value){
    var prevTh = i===0 ? 0 : TIERS[i-1].th;
    var span = TIERS[i].th - prevTh; if (span<=0) span=1;
    return Math.max(0, Math.min(100, (vFor(value, TIERS[i])-prevTh)/span*100));
  }
  /* The popup's own bar — the separate line under the tier you tapped — is the ONE place that
     measures from zero, so tapping the EUR 275 bracelet on a EUR 49 cart shows a quarter filled
     rather than nothing. Deliberately NOT segPct: that one is shared with the drawer's reward
     chips, and using it here put a fill inside every card on both surfaces. */
  function tierPct(th, value){
    if (!th) return 100;
    return Math.max(0, Math.min(100, (value / th) * 100));
  }
  // Kept to ONE line. The chip directly beneath already names the reward, so the headline uses
  // the short name and the shorter "more for" — "Spend € 96,00 more to get Free travel case"
  // wraps at 340px, "Spend € 96,00 more for Travel case" does not.
  function headline(i, TIERS, value){
    var t = TIERS[i];
    // Once every tier is met, say so outright rather than dwelling on the last reward.
    if (nextIdx(value, TIERS) === -1) return '<b>' + esc(T('all-gifts-unlocked', null, 'All gifts unlocked')) + '</b> &#10003;';
    /* The status word is the i18n block's, as in the gift picker's heading ("<label> — unlocked"):
       typed here it stayed English on /nl, /de and /fr under a translated label. */
    if (unlocked(value, t)) return '<b>' + esc(fullLabel(t.label)) + '</b> — ' + esc(T('unlocked-suffix', null, 'unlocked'));
    /* The gap MUST be measured with vFor(), the same quantity unlocked() tests — the translated
       branch used the raw cart value while the English fallback used vFor(), so the two disagreed
       by curOrderDisc and the headline could read "Spend € -23,00 more" on a cart the ladder still
       called locked (Kai, 23 Sept). Clamped at zero as well: a gap that is not positive is not a
       gap, and no arithmetic here should ever be able to print a minus sign at a customer. */
    var gap = Math.max(0, t.th - vFor(value, t));
    /* data-cr-count: the amount rolls up to this figure while the chips fill (see runCount). */
    var amt = '<b data-cr-count="' + gap + '">' + fmt(gap) + '</b>';
    return TH('spend-more-for', { amount: amt, reward: esc(midSentence(t.label)) },
      'Spend ' + amt + ' more for ' + esc(midSentence(t.label)));
  }
  // A tier with no product image gets an ICON, not a green tile with its own name in it.
  //
  // Two problems with the tile: in this cart green means UNLOCKED — the chips, the tick and the
  // rail all use it — so a green square on a tier the customer has not reached made an unearned
  // reward look earned. And the label was already written directly to its right, so the tile spent
  // 52px repeating a word.
  //
  // The icon is chosen per tier so it says something the text does not: a van for delivery, a tag
  // for money off, a gift for a product. One generic mark repeated three times would be worth less
  // than the text it replaced.
  var CR_ICONS = {
    ship: '<path d="M3 7h10v9H3z"/><path d="M13 10h4l3 3v3h-7z"/>'
        + '<circle cx="7" cy="18" r="1.6"/><circle cx="17" cy="18" r="1.6"/>',
    off:  '<path d="M19 5L5 19"/><circle cx="7.5" cy="7.5" r="2.5"/><circle cx="16.5" cy="16.5" r="2.5"/>',
    gift: '<path d="M4 11h16v9H4z"/><path d="M3 7h18v4H3z"/><path d="M12 7v13"/>'
        + '<path d="M12 7S10.5 3 8.5 4s.5 3 3.5 3z"/><path d="M12 7s1.5-4 3.5-3-.5 3-3.5 3z"/>'
  };
  function thumbIcon(tier){
    var key = 'gift';
    /* Decided on the tier's DATA, never on its words (engineering rule 1). This used to look for
       "shipping", "delivery" and " off" in the label — but the label is campaign copy, translated
       per language since 23 Sept, so on /nl ("Gratis verzending"), /de and /fr the shipping tier
       drew a gift instead of a van. The shipping tier carries type "shipping" (it is also how its
       threshold follows the destination, see ntfFixShipTier); a money-off tier may name its
       discount; and a per-cent sign is the same character in every language. A gift tier is never
       "off", whatever discount frees it. */
    if (tier.type === 'shipping') key = 'ship';
    else if (tier.type !== 'gift_choice' && tier.type !== 'auto_gift'
             && (tier.discount || fullLabel(tier.label).indexOf('%') !== -1)) key = 'off';
    return '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"'
      + ' stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">'
      + CR_ICONS[key] + '</svg>';
  }
  function paintThumb(el, tier){
    if (tier.img){
      el.style.backgroundImage = 'url(' + tier.img + ')';
      el.innerHTML = '';
      el.classList.remove('cr-thumb-badge', 'cr-thumb-icon');
    } else {
      el.style.backgroundImage = '';
      el.innerHTML = thumbIcon(tier);
      el.classList.remove('cr-thumb-badge');
      el.classList.add('cr-thumb-icon');
    }
  }
  function esc(s){ return (s||'').replace(/[&<>"]/g, function(c){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[c]; }); }

  /* The claim banner reaches the edges of whatever holds it. Measured, not hardcoded: it renders
     inside the cart page's card (14px of padding) and inside the drawer (20px), so one negative
     margin cannot serve both. The widest ancestor within four hops is the container; the bleed is
     capped at 40px a side so an unexpected parent cannot stretch it across the page. */
  /* The banner is painted while the drawer is still shut, where it measures zero — so it is also
     watched, and measured again the moment it has a size. */
  var bandRO = window.ResizeObserver ? new ResizeObserver(function(entries){
    entries.forEach(function(e){ bleedBand(e.target); });
  }) : null;
  function bleedBand(el){
    if (!el) return;
    if (bandRO && !el.dataset.crWatched){ el.dataset.crWatched = '1'; bandRO.observe(el); }
    var want = el.style.marginLeft;
    el.style.marginLeft = el.style.marginRight = '';
    var band = el.getBoundingClientRect();
    if (!band.width){ el.style.marginLeft = want; return; }
    var host = null, n = el.parentElement;
    for (var i = 0; i < 4 && n; i++, n = n.parentElement){
      var r = n.getBoundingClientRect();
      if (r.width > (host ? host.getBoundingClientRect().width : band.width)) host = n;
    }
    if (!host) return;
    var h = host.getBoundingClientRect();
    /* The CLIENT box, not the border box: on a scrolling host the border box includes the
       vertical scrollbar, and a band stretched to it overflows by exactly that width — which is
       what drew a horizontal scrollbar under the cart's totals. */
    var hLeft  = h.left + (host.clientLeft || 0);
    var hRight = hLeft + (host.clientWidth || h.width);
    var l = Math.min(40, Math.max(0, Math.round(band.left - hLeft)));
    var r2 = Math.min(40, Math.max(0, Math.round(hRight - band.right)));
    if (!l && !r2) return;
    el.style.marginLeft  = -l + 'px';
    el.style.marginRight = -r2 + 'px';
  }

  // ---- Row (Concept B, drawer only — the cart-page banner has no compact UI to paint) ----
  // Whether a gift has been picked, for the claim banner. Read from the cart and cached; the row
  // markup carries no such flag, and asking on every paint would be a request per repaint.
  var gcChosenCount = null;
  // The gift tier has no linked product of its own — the whole point is that the customer picks it.
  // So the tier borrows the picture of whatever they actually chose, read from the cart line. Until
  // they choose, there is nothing honest to show and the tier falls back to its label badge.
  var gcChosenImg = null;
  function refreshGiftChosen(){
    return fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        rememberCart(cart);   // the read every page load makes - see lastCart
        var n = 0, img = null;
        (cart.items || []).forEach(function(it){
          if (it.properties && it.properties._gift_choice){
            n += it.quantity;
            // featured_image.url is the variant shot when the variant has one, else the product's.
            if (!img) img = (it.featured_image && it.featured_image.url) || it.image || null;
          }
        });
        var changed = gcChosenCount !== n || gcChosenImg !== img;
        gcChosenCount = n;
        gcChosenImg = img;
        if (changed) repaintRows();
        return n;
      }).catch(function(){ return 0; });
  }

  // Every read of a tier's artwork goes through these two, so the gift tier picks up the chosen
  // bracelet everywhere at once — ladder, NEXT REWARD panel and the won view.
  function tierImg(t){
    if (t && t.type === 'gift_choice' && gcChosenImg) return gcChosenImg;
    return t && t.img;
  }
  function tierImgs(t){
    if (t && t.type === 'gift_choice' && gcChosenImg) return [gcChosenImg];
    return (t && Array.isArray(t.imgs)) ? t.imgs : [];
  }

  /* The four reward pictures, from the picker's own payload (rendered on every page), so this list
     shows exactly what the picker will. Bundle first, as the picker orders them. */
  function rewardPics(){
    var m = document.getElementById('gcp-modal');
    if (!m) return [];
    var d; try { d = JSON.parse(m.getAttribute('data-gc') || '{}'); } catch(e){ return []; }
    var out = [];
    /* The bundle IS the bracelet, whatever its card is called — so it is not worked out from its
       title at all. */
    if (d.bundle && d.bundle.items && d.bundle.items.length){
      out.push({ img: (d.bundle.items[0] && d.bundle.items[0].img) || d.bundle.img || '', kind: 'bracelet', title: d.bundle.title || '' });
    }
    (d.gifts || []).forEach(function(g){ out.push({ img: g.img, kind: picKind(g.url), title: g.title }); });
    return out.slice(0, 4);
  }
  /* Which reward a gift is, read from its HANDLE (the last part of its URL). It used to be read
     from the title with /mug/, /wallet/, /case/ — but the title is product copy, and since the
     switch to Shopify's own translations Liquid prints it in the visitor's language: "Koffiemok die
     je zelf kunt personaliseren", "Reise-Etui aus Leder", "Portefeuille en Cuir Noir". None of those
     matched, so on /nl, /de and /fr the cells fell through to the title's first two words. Handles
     are not translated on this store. The reward duplicates are leather-travel-case-free-gift,
     genuine-black-leather-wallet-free-gift and personalizable-coffee-mug-free-gift; outside gift-
     product mode the travel case is the original silver-jewellery-box. No regex on purpose. */
  function picKind(url){
    var h = String(url || '').split('?')[0].split('/').pop().toLowerCase();
    if (h.indexOf('mug') !== -1) return 'mug';
    if (h.indexOf('wallet') !== -1) return 'wallet';
    if (h.indexOf('case') !== -1 || h.indexOf('jewellery-box') !== -1) return 'case';
    if (h.indexOf('bracelet') !== -1) return 'bracelet';
    return '';
  }
  /* A card title is too long for a 70px cell: 'Personalizable Coffee Mug' becomes 'Mug'. The short
     names come from the i18n block; a reward this does not know keeps the first two words of its
     own (already translated) title. */
  function picLabel(kind, title){
    if (kind === 'mug') return T('pic-mug', null, 'Mug');
    if (kind === 'wallet') return T('pic-wallet', null, 'Wallet');
    if (kind === 'case') return T('pic-case', null, 'Travel case');
    if (kind === 'bracelet') return T('pic-bracelet', null, 'Bracelet');
    return String(title || '').split(' ').slice(0, 2).join(' ');
  }

  /* Design E: the accordion. Earned tiers collapse to a struck line with a tick; the next tier
     opens with its own progress, its description or the reward photographs, and a way in. Every
     tier is a control: the gift tier goes to the picker (browse mode while locked), the others to
     the tiers popup — the same two doors the drawer's row opens. */
  function paintAccordion(row){
    var box = row.querySelector('[data-cr-acc]');
    if (!box) return;
    var TIERS = getTiers(row);
    var value = +row.dataset.value;
    curOrderDisc = +row.dataset.orderDisc || 0;
    var ni = nextIdx(value, TIERS);
    var chosen = gcChosenCount > 0;
    /* A text glyph, not an SVG: the theme's global svg{fill:currentColor} filled the drawn path into a
       blob. The same &#10003; the gift-box row and the tier chips print. */
    var tick = '<i class="cr-acc-ok" aria-hidden="true">&#10003;</i>';
    var h = '';
    TIERS.forEach(function(t, i){
      var un = unlocked(value, t);
      var isNext = (i === ni);
      var isGift = t.type === 'gift_choice';
      var door = isGift ? ' data-cr-giftchip="' + (un ? 'open' : 'locked') + '"' : ' data-cr-open';
      var status;
      /* A plus on every threshold: "€ 175" reads as a price, "€ 175+" as the floor it is. */
      var thr = t.th < 100 ? thLabel(t.th) : fmtRound(t.th) + '+';
      if (un) status = thr + ' · ' + (isGift && chosen ? T('chosen', null, 'Chosen') : T('unlocked', null, 'Unlocked'));
      else if (isNext) status = thr + ' · ' + toGo(t.th - vFor(value, t));
      else status = thr;
      var cls = 'cr-acc-t' + (un ? ' is-done' : '') + (isNext ? ' is-next' : '');
      h += '<div class="' + cls + '"' + door + ' role="button" tabindex="0">'
        + '<div class="cr-acc-head">'
          + (un ? tick : '<span class="cr-acc-dot"></span>')
          + '<span class="cr-acc-lb">' + esc(fullLabel(t.label)) + '</span>'
          + '<span class="cr-acc-st">' + status + '</span>'
        + '</div>';
      if (isNext){
        var prevTh = i === 0 ? 0 : TIERS[i-1].th;
        var span = t.th - prevTh; if (span <= 0) span = 1;
        var pct = Math.max(3, Math.min(100, Math.round((vFor(value, t) - prevTh) / span * 100)));
        h += '<div class="cr-acc-bar"><i style="width:' + pct + '%"></i></div>';
        if (isGift){
          var pics = rewardPics();
          if (pics.length){
            h += '<div class="cr-acc-pics">' + pics.map(function(p){
              return '<span class="cr-acc-pic"><img src="' + p.img + '" alt="" loading="lazy"><span>' + esc(picLabel(p.kind, p.title)) + '</span></span>';
            }).join('') + '</div>';
          }
          h += '<p class="cr-acc-note">' + esc(T('pick-one-at', { amount: fmtRound(t.th) }, 'Pick one at ' + fmtRound(t.th) + '.'))
             + ' <u>' + esc(T('view-all-rewards', null, 'View all rewards')) + ' &rsaquo;</u></p>';
        } else if (t.desc){
          h += '<p class="cr-acc-note">' + esc(t.desc) + '</p>';
        }
      }
      h += '</div>';
    });
    if (ni === -1){
      h += '<p class="cr-acc-note cr-acc-note--won">' + esc(T('all-rewards-unlocked', null, 'All rewards unlocked'))
         + (chosen ? '' : ' — <u data-cr-pickgift>' + esc(T('choose-your-reward-inline', null, 'choose your reward')) + '</u>') + '</p>';
    }
    /* Signature, not an innerHTML comparison (see the chips): entities and styles do not
       round-trip, and a rewrite on every paint restarts the bar and re-triggers the observer. */
    var sig = value + '|' + ni + '|' + (chosen ? 1 : 0) + '|' + TIERS.map(function(x){ return x.th; }).join(',');
    if (box.dataset.crSig !== sig){ box.dataset.crSig = sig; box.innerHTML = h; }
  }

  function paintRow(row){
    var thumbEl = row.querySelector('.cr-thumb');
    if (!thumbEl) return;
    if (row.hasAttribute('data-cr-accordion')) paintAccordion(row);
    var TIERS = getTiers(row);
    if (!TIERS.length) return;
    var value = +row.dataset.value;
    curOrderDisc = +row.dataset.orderDisc || 0;
    var view = +row.dataset.view;
    if (isNaN(view) || !TIERS[view]) view = defaultView(value, TIERS);
    paintThumb(thumbEl, TIERS[view]);
    row.querySelector('.cr-headline').innerHTML = headline(view, TIERS, value);
    var chipsHold = row.querySelector('.cr-rchips');
    if (chipsHold) holdCount(chipsHold);
    // one segment per tier, filled once that tier is unlocked
    var segsEl = row.querySelector('.cr-segs');
    if (segsEl){
      var s = '';
      TIERS.forEach(function(tt){ s += '<i class="' + (unlocked(value, tt) ? 'on' : '') + '"></i>'; });
      if (segsEl.innerHTML !== s) segsEl.innerHTML = s;
    }
    // The chip line. Each chip is its own segment of the progress meter: the tint behind the
    // label grows left to right as the cart approaches that tier, so there is no separate bar to
    // draw and the row loses a whole line of height.
    // Claim banner: a gift tier unlocked with nothing chosen yet.
    // It spans its container edge to edge — see bleedBand.
    var bandEl = row.querySelector('[data-cr-banner]');
    if (bandEl){
      var gcTier = null;
      TIERS.forEach(function(t){ if (t.type === 'gift_choice' && unlocked(value, t)) gcTier = t; });
      var claim = !!gcTier && gcChosenCount === 0;
      row.classList.toggle('is-claim', claim);
      bandEl.hidden = !claim;
      if (claim) warmPickPictures();
      // The whole strip is the target, not just the words 'Choose now'. Only the small underlined
      // span carried the handler, so most of a full-width banner did nothing when tapped — and on
      // a phone that span is a ~70px target inside a ~340px bar.
      if (claim) bandEl.setAttribute('data-cr-pickgift', '');
      else bandEl.removeAttribute('data-cr-pickgift');
      if (claim){
        var sig = 'claim|' + gcTier.th;
        if (bandEl.dataset.crSig !== sig){
          bandEl.dataset.crSig = sig;
          bandEl.innerHTML = '<span class="cr-band-t">'
            /* midSentence, not toLowerCase(): lowering the WHOLE label put every German noun in
               lower case ("Sie haben ihre belohnung verdient"). */
            + esc(T('earned-reward', { reward: midSentence(gcTier.label) },
                    'You\u2019ve earned ' + midSentence(gcTier.label) + '.'))
            + '</span>'
            + '<span class="cr-band-cta" data-cr-pickgift>' + esc(T('choose-now', null, 'Choose now')) + '</span>';
        }
        bleedBand(bandEl);
      }
    }

    var chipsEl = row.querySelector('.cr-rchips');
    if (chipsEl) paintChipRow(chipsEl, TIERS, value);
  }

  /* ---- The chip row, shared -------------------------------------------------------------------
     One builder for the drawer row AND for the popup on phones (Kai, 24 Sept: "use the exact same
     design we have on mobile in the cart drawer"). Same function, same classes, same CSS — so the
     two cannot drift, which is the whole reason the rail was rebuilt rather than restyled. */
  /* NOT paintChips: this file already has a no-argument paintChips() further down, and the later
     declaration wins — every call here silently resolved to that one and rendered nothing. */
  function paintChipRow(chipsEl, TIERS, value){
    var ni = nextIdx(value, TIERS);
    var c = '';
    TIERS.forEach(function(tt, i){
      var on = unlocked(value, tt);
      var cls = 'cr-rchip' + (on ? ' is-on' : (i === ni ? ' is-next' : ''));
      // Rendered at width:0 and raised to the real figure on the next frame — a width set in
      // the same paint as the element is created does not transition, and the fill growing is
      // the whole point.
      /* The gift chip is a shortcut to the rewards themselves — browse mode while locked, the
         real picker once earned. The row around it still opens the ladder for every other tier. */
      var giftChip = tt.type === 'gift_choice' ? (on ? 'open' : 'locked') : '';
      c += '<span class="' + cls + '" data-cr-fill="' + segPct(i, TIERS, value) + '"'
        + (giftChip ? ' data-cr-giftchip="' + giftChip + '" title="' + esc(T('see-the-rewards', null, 'See the rewards')) + '"' : '') + '>'
        + '<i class="cr-rchip-fill"></i>'
        /* The amount on every LOCKED chip, and the tick INSTEAD of it once the tier is reached
           (Kai, 24 Sept: "the checkmark should be added once the tier is reached and replace the
           price to save space"). Showing both was tried first and the margin was 2-3px in NL, DE
           and FR - the tick buys that space back on exactly the chip that no longer needs its
           figure, because a threshold already passed is not information any more. */
        + '<span class="cr-rchip-d">' + (on ? '&#10003;' : fmtRound(tt.th)) + '</span>'
        + '<span class="cr-rchip-l">' + esc(shortLabel(tt.label)) + '</span>'
      + '</span>';
    });
    // Signature, not an innerHTML comparison — see the note in cart-giftchoice-popup:
    // innerHTML round-trips entities and styles, so the comparison never matched and the
    // chips were rewritten on every paint.
    var sig = value + "|" + ni + "|" + TIERS.map(function(x){ return x.th; }).join(",");
    if (chipsEl.dataset.crSig === sig) return;
    chipsEl.dataset.crSig = sig;
    chipsEl.innerHTML = c;
    /* The fill runs ONCE, where it can be seen, and a rebuilt row carries on from what was on
       screen (Kai, 25 Sept, Fix 3: "it loads instant, resets and then loads fully"). The drawer is
       built at page load, hidden, so its fill used to finish out of sight; then an add to cart
       re-renders the drawer (and the popup repaints once its cart read lands), the chips were
       rebuilt at zero and filled a second time. Now each surface remembers the fill it last showed:
       a new row starts there, without a transition, and animates only the difference - and it
       waits until it is actually on screen. */
    var kind = fillKind(chipsEl);
    var to = [].map.call(chipsEl.querySelectorAll('[data-cr-fill]'), function(ch){
      return Math.max(0, Math.min(100, +ch.dataset.crFill || 0)) / 100;
    });
    var from = fillNow(FILL_MEM[kind]);
    if (!from || from.length !== to.length) from = to.map(function(){ return 0; });
    chipsEl.querySelectorAll('.cr-rchip-fill').forEach(function(f, i){
      f.style.transition = 'none';
      f.style.transform = 'scaleX(' + from[i] + ')';
    });
    var mem = { from: from, to: to, delay: [], dur: [], t0: 0, started: false };
    /* A fill from empty also rolls the "Spend X more" amount up from zero (see runCount). */
    mem.fresh = from.every(function(x){ return x === 0; }) && to.some(function(x){ return x > 0; });
    FILL_MEM[kind] = mem;
    holdCount(chipsEl);
    whenVisible(chipsEl, function(){ runFill(chipsEl, mem); });
  }
  /* ---- The "Spend € X more" amount counts up while the chips fill (Kai, 25 Sept) ---------------
     It waits at zero with the chips, then rolls up to its figure over the same time as the fill
     (at least 600ms, at most 1100ms, easing out so it settles rather than stops). Whole euros on
     the way, the exact figure at the end. Only on a fill from empty - a row rebuilt with the fill
     carried over shows its figure as it is. Reduced motion: the figure, at once. */
  function countEls(chipsEl){
    var scope = chipsEl.closest('[data-cr-row], #cr-a1') || chipsEl.parentElement;
    return scope ? scope.querySelectorAll('.cr-headline [data-cr-count], .cr-a1-nudge [data-cr-count]') : [];
  }
  function holdCount(chipsEl){
    var mem = FILL_MEM[fillKind(chipsEl)];
    if (!mem || !mem.fresh || mem.started) return;
    [].forEach.call(countEls(chipsEl), function(b){ setCount(b, fmt(0)); });
  }
  /* The figure is written into its text node's data, not with textContent: replacing children is a
     childList change, which the shared NTF_ON_MUTATE observer answers by running every guard on the
     page - once per frame for as long as the count runs. A text node's data is a characterData
     change, which nothing here observes. */
  function setCount(b, txt){
    var n = b.firstChild;
    if (n && n.nodeType === 3 && !n.nextSibling){ if (n.data !== txt) n.data = txt; }
    else b.textContent = txt;
  }
  function runCount(chipsEl, mem, start, total){
    var reduce = false;
    try { reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch(e){}
    var dur = Math.min(1100, Math.max(600, total));
    var t0 = Date.now() + start;
    (function tick(){
      if (FILL_MEM[fillKind(chipsEl)] !== mem) return;   // a newer fill owns the row now
      var p = reduce ? 1 : Math.max(0, Math.min(1, (Date.now() - t0) / dur));
      var e = 1 - Math.pow(1 - p, 3);
      [].forEach.call(countEls(chipsEl), function(b){
        var to = +b.getAttribute('data-cr-count') || 0;
        setCount(b, p >= 1 ? fmt(to) : fmt(Math.round(to * e / 100) * 100));
      });
      if (p < 1) requestAnimationFrame(tick);
    })();
  }
  /* Per surface - the drawer, the popup, the product page - the fill it last showed. */
  var FILL_MEM = {};
  function fillKind(el){
    if (el.closest('#cr-modal')) return 'popup';
    if (el.closest('#CartDrawer, #x-cart-drawer-container')) return 'drawer';
    return 'page';
  }
  /* Where a remembered fill is on screen right now: the runs are linear, so each chip's position
     follows from its delay and duration. */
  function fillNow(mem){
    if (!mem) return null;
    var e = Date.now() - mem.t0;
    return mem.to.map(function(to, i){
      var from = mem.from[i], d = mem.delay[i] || 0, u = mem.dur[i] || 0;
      if (!mem.started || e <= d) return from;
      if (!u || e >= d + u) return to;
      return from + (to - from) * (e - d) / u;
    });
  }
  /* Run cb once the element is at least 60% on screen: the drawer sliding in, the product page
     row scrolled to, the popup opening. */
  function whenVisible(el, cb){
    if (!('IntersectionObserver' in window)){ requestAnimationFrame(cb); return; }
    var io = new IntersectionObserver(function(entries){
      if (!entries.some(function(x){ return x.isIntersecting; })) return;
      io.disconnect();
      requestAnimationFrame(cb);
    }, { threshold: 0.6 });
    io.observe(el);
  }
  function runFill(chipsEl, mem){
    if (!chipsEl.isConnected || FILL_MEM[fillKind(chipsEl)] !== mem) return;
    /* ONE fill across the row, not three at once (Kai, 25 Sept): each chip starts when the one
       before it has finished, at one constant speed, linear, so the green reads as a single bar.
       504ms per full chip - 20% slower than the 420ms before (Kai, 25 Sept, Fix 3). A row that is
       emptying (an item removed) runs right to left, so the bar shrinks from its end. In the popup
       the fill waits for the popup's own entrance to finish. Reduced motion is untouched: the
       stylesheet's transition:none leaves nothing to time. */
    var PER_CHIP = 504, at = 0;
    var modal = chipsEl.closest('#cr-modal');
    if (modal && modal.__ntfOpenedAt) at = Math.max(0, 420 - (Date.now() - modal.__ntfOpenedAt));
    var countStart = at;
    var fills = [].slice.call(chipsEl.querySelectorAll('.cr-rchip-fill'));
    var sum = function(a){ return a.reduce(function(s, x){ return s + x; }, 0); };
    var order = fills.map(function(f, i){ return i; });
    if (sum(mem.to) < sum(mem.from)) order.reverse();
    void chipsEl.offsetWidth;   // the start position is on screen before the transition is set
    order.forEach(function(i){
      var f = fills[i];
      var dur = Math.round(PER_CHIP * Math.abs(mem.to[i] - mem.from[i]));
      f.style.transition = '';
      f.style.transitionTimingFunction = 'linear';
      f.style.transitionDuration = dur + 'ms';
      f.style.transitionDelay = at + 'ms';
      f.style.transform = 'scaleX(' + mem.to[i] + ')';
      mem.delay[i] = at; mem.dur[i] = dur;
      at += dur;
    });
    mem.t0 = Date.now(); mem.started = true;
    if (mem.fresh) runCount(chipsEl, mem, countStart, at - countStart);
  }
  // Chips have room for a name, not a sentence: "Free Bracelet" becomes "Bracelet". The leading
  // word is dropped and the next one re-capitalised, so it does not read "travel case". The full
  // label is still used in the headline and the popup.
  // A tier label may carry BOTH wordings in one metaobject field, separated by a pipe:
  //   "Free beaded bracelet|Bracelet"
  // Left of the pipe is the full wording for sentences and headings; right is the chip. Done this
  // way because the chip needs to be shorter than the sentence and no rule can derive one from the
  // other — dropping the leading word turns "Free beaded bracelet" into "Beaded bracelet" (still
  // too long for a chip), and taking the last word would turn "Travel case" into "Case". Without a
  // pipe both fall back to the old behaviour, so existing campaigns are unaffected.
  function fullLabel(label){
    return String(label || '').split('|')[0].trim();
  }
  function shortLabel(label){
    var parts = String(label || '').split('|');
    if (parts.length > 1 && parts[1].trim()) return parts[1].trim();
    var s = parts[0].trim().replace(/^\s*(free|gratis|gratuit|kostenlos)\s+/i, '');
    return s.charAt(0).toUpperCase() + s.slice(1);
  }
  // Mid-sentence the label must not shout: "more for free beaded bracelet", not "...for Free…".
  // Only the first character is touched, so "10% off" survives untouched.
  /* Never in German, where the capital is grammar, not style: nouns keep it (Versand, Rabatt), and
     the formal "Ihre Belohnung" lowered to "ihre" reads as HER reward — "Noch 26 € für ihre
     Belohnung". Decided on the page's language code, a VALUE, never on the words themselves; the
     same rule as inSentence() in the gift picker. EN, NL and FR are unchanged. */
  function midSentence(label){
    var s = fullLabel(label);
    var lang = (document.documentElement.lang || '').toLowerCase();
    if (lang === 'de' || lang.indexOf('de-') === 0) return s;
    return s.charAt(0).toLowerCase() + s.slice(1);
  }
  function initRow(row){
    if (row.dataset.crReady) return;
    row.dataset.crReady = '1';
    var TIERS = getTiers(row);
    row.dataset.view = defaultView(+row.dataset.value, TIERS);
    paintRow(row);
  }
  function scanRows(){
    document.querySelectorAll('[data-cr-row]').forEach(initRow);
  }
  /* Every row on the page, repainted with what is known NOW. scanRows() only paints rows it has not
     seen, so a gift count read after a row was first painted never reached it: the cart page's row
     is server-rendered once and never re-rendered like the drawer's, so it kept "All gifts unlocked"
     and never showed the "choose your gift" banner the drawer does (Kai, 28 Sept: "ensure these
     behaviours match identically between cart page and cart drawer"). */
  function repaintRows(){
    document.querySelectorAll('[data-cr-row]').forEach(function(r){
      if (!r.dataset.crReady){ initRow(r); return; }
      if (r.classList.contains('ntf-strip')) paintStrip(r); else paintRow(r);
    });
  }

  // Repaint the full-width cart-page strip (server-rendered, so this only updates state).
  function paintStrip(el){
    var TIERS = getTiers(el);
    var value = +el.dataset.value;
    curOrderDisc = +el.dataset.orderDisc || 0;
    var n = nextIdx(value, TIERS);
    var nudge = el.querySelector('[data-ntf-nudge]');
    if (nudge){
      nudge.innerHTML = (n === -1)
        ? esc(T('all-gifts-unlocked', null, 'All gifts unlocked')) + ' &#10003;'
        /* Clamped for the same reason as headline(): never print a negative gap. */
        : TH('spend-more-to-get', { amount: '<b>' + fmt(Math.max(0, TIERS[n].th - vFor(value, TIERS[n]))) + '</b>', reward: esc(midSentence(TIERS[n].label)) },
            'Spend <b>' + fmt(TIERS[n].th - vFor(value, TIERS[n])) + '</b> more to get ' + esc(midSentence(TIERS[n].label)));
    }
    el.querySelectorAll('.ntf-strip-c').forEach(function(card, i){
      var t = TIERS[i]; if (!t) return;
      var done = unlocked(value, t);
      card.classList.toggle('is-done', done);
      card.classList.toggle('is-next', i === n);
      var img = card.querySelector('.ntf-strip-im');
      if (img && !img.classList.contains('ntf-strip-im--badge')) img.classList.toggle('is-locked', !done);
      var st = card.querySelector('[data-ntf-st]');
      if (st){
        st.innerHTML = done
          ? '<span class="ntf-tick">&#10003;</span> ' + esc(T('unlocked', null, 'Unlocked'))
          : toGo(t.th - vFor(value, t));
      }
    });
  }

  // Fill the compact "Delivery …" disclosure from the theme's own (visually hidden) estimate
  // line, so we reuse its per-market date logic instead of recomputing it.
  function syncDelivery(){
    // [data-ntf-deliv-keep] opts out: the delivery SHEET's title carries data-ntf-deliv because
    // that is how ntf-ship-sheet.js finds the panel, but its text is a title, not a date slot —
    // rewriting it turned "Delivery information" into "Delivery August 31".
    var labels = [].slice.call(document.querySelectorAll('[data-ntf-deliv]'))
      .filter(function(el){ return !el.hasAttribute('data-ntf-deliv-keep'); });
    if (!labels.length) return;
    /* Last resort, not first writer. This reads the theme's own estimate — "Delivery September
       04" — and needs no network, so it always won the race against the live rates and the row
       visibly changed to "Delivery Fri Sep 4" a second later. It now waits for the rates to
       settle, and writes only if they came back with no date at all. Until then the row keeps the
       neutral label the drawer rendered server-side. */
    var shipState = window.NTF_SHIP_STATE;
    if (shipState && (!shipState.settled || shipState.hasDate)) return;
    // read the theme's own estimate line (cart page keeps it hidden as .ntf-estimate-src;
    // the drawer renders its own visible one) so we reuse its per-market date logic
    var srcs = document.querySelectorAll('.ntf-estimate-src, [id^="x-estimate-delivery"]');
    var txt = '';
    for (var i = 0; i < srcs.length; i++){
      // textContent, not innerText — it works even for hidden/clipped nodes
      var t = (srcs[i].textContent || '').replace(/\s+/g, ' ').trim();
      if (t) { txt = t; break; }
    }
    if (!txt) return;
    // keep the date-ish tail, e.g. "August 07." / "07 Aug" / "Aug 5 - Aug 9"
    var m = txt.match(/((?:\d{1,2}\s+)?[A-Za-zÀ-ÿ]+\.?\s*\d{1,2}(?:\s*[-–]\s*.+)?)\.?$/);
    var when = m ? m[1].replace(/\.$/, '') : '';
    if (!when) return;
    // IMPORTANT: only write when the text actually changes. These labels live inside the
    // drawer container watched by the MutationObserver below, and assigning textContent
    // replaces child nodes — an unconditional write re-triggers the observer, which calls
    // this again, freezing the renderer.
    var next = T('delivery', null, 'Delivery') + ' ' + when;
    labels.forEach(function(el){ if (el.textContent !== next) el.textContent = next; });
    var det = document.querySelector('.ntf-fdet--deliv');
    if (det && det.hidden) det.hidden = false;
    // now that the date has been captured, collapse the theme's own estimate line
    srcs.forEach(function(el){ el.classList.add('ntf-estimate-read'); });
  }

  // Re-read the cart and update every row in place, so changing a quantity updates the tiers
  // immediately instead of waiting for a page refresh. Mirrors the Liquid eligibility maths:
  // original_total_price minus any free (line_price === 0) lines.
  /* The two figures the Liquid producers emit (cart-rewards-row): what the customer pays for
     everything that is not a gift after every discount, and the order-level discount on top of it —
     the reward tiers add it back (see vFor). cart.js: final_line_price is after line-level discounts
     only, line_price after the order-level allocation as well. One copy, because the row refresh and
     the popup must never disagree about what the cart is worth. */
  function cartFigures(cart){
    var pre = (cart && cart.items_subtotal_price) || 0, post = (cart && cart.total_price) || 0;
    ((cart && cart.items) || []).forEach(function(it){
      var p = it.properties || {};
      if (p._gift_choice || p._Gifted || p._auto_gift){
        pre -= (it.final_line_price || 0); post -= (it.line_price || 0);
      }
    });
    return { value: Math.max(0, post), orderDisc: Math.max(0, pre - post),
             pay: (cart && cart.total_price) || 0 };
  }

  var refreshTimer = null;
  function refreshRows(){
    clearTimeout(refreshTimer);
    refreshTimer = setTimeout(function(){
      fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
        .then(function(r){ return r.json(); })
        .then(function(cart){
          rememberCart(cart);
          var fig = cartFigures(cart);
          var value = fig.value, orderDisc = fig.orderDisc;
          var rows = document.querySelectorAll('[data-cr-row]');
          if (!rows.length) return;
          rows.forEach(function(row){
            row.dataset.value = value;
            row.dataset.orderDisc = orderDisc;
            row.dataset.pay = cart.total_price;
            var TIERS = getTiers(row);
            row.dataset.view = defaultView(value, TIERS);
            if (row.classList.contains('ntf-strip')) paintStrip(row);
            else paintRow(row);
          });
          syncDelivery();
          // keep an open popup in sync too
          if (state){
            state.value = value;
            state.pay = cart.total_price;
            state.cartProductIds = (cart.items || []).map(function(i){ return i.product_id; });
            state.cartItems = cart.items || [];   // line discounts live here
            state.recsHtml = null; // cart changed → recommendations may differ
            if (document.getElementById('cr-modal').style.display === 'flex') paintModal();
          }
        })
        .catch(function(){});
    }, 120);
  }

  // Shopify cart mutations all go through these endpoints; wrapping fetch catches every
  // quantity change regardless of which theme script triggered it.
  if (window.fetch && !window.__crFetchPatched){
    window.__crFetchPatched = true;
    var _fetch = window.fetch;
    window.fetch = function(input, init){
      var url = (typeof input === 'string') ? input : (input && input.url) || '';
      var isCartWrite = /\/cart\/(add|change|update|clear)(\.js)?/.test(url);
      return _fetch.apply(this, arguments).then(function(res){
        if (isCartWrite) refreshRows();
        return res;
      });
    };
  }

  // ---- Popup: vertical tier ladder ----
  var state = null;
  // Total worth of the gifts that carry a price. Percentage tiers contribute nothing here — we
  // can't state a number for them without knowing the cart, and an invented figure is worse than
  // none.
  // What a discount tier is ACTUALLY saving right now, read from the cart's own line-level
  // discount allocations — never computed from a percentage. Shopify decides which items are
  // eligible; reading the applied amount means the figure always matches what the customer will
  // be charged. Returns 0 when the named discount is not on the cart.
  function appliedDiscount(title){
    if (!title || !state.cartItems) return 0;
    var sum = 0;
    state.cartItems.forEach(function(it){
      (it.discounts || []).forEach(function(d){
        if (d && d.title === title) sum += (+d.amount || 0);
      });
    });
    return sum;
  }
  // The value of a tier: a linked product's price, or the real discount it is applying.
  function tierWorth(t){
    return t.discount ? appliedDiscount(t.discount) : (+t.worth || 0);
  }
  function totalWorth(){
    var sum = 0;
    (state.TIERS || []).forEach(function(t){ sum += tierWorth(t); });
    return sum;
  }

  // ---- All rewards earned ----------------------------------------------------------------
  // The popup's job changes here: it is no longer "spend more", it is "you earned all of this,
  // go and check out". One markup, two treatments — a centred trio on desktop, stacked rows on
  // mobile (see .cr-won-* in ntf-cart.css).
  function paintWon(){
    var worth = totalWorth();
    // "All unlocked" is not the same as "all claimed". A gift_choice tier can be unlocked with no
    // bracelet chosen; sending that customer to checkout would charge them and hand over nothing.
    var gcPending = state.TIERS.some(function(t){
      return t.type === 'gift_choice' && vFor(state.value, t) >= t.th;
    }) && !state.giftChosen;

    // One band, three cells: the threshold that earned each reward, a tick, and the reward itself.
    // No imagery and no per-item value line — this view is a confirmation, not a sales pitch, and
    // the old three-tile layout was tall enough to leave the dialog padded out with empty white.
    // The threshold is here because "You earned all 3" never said what "all 3" cost to reach.
    // Three separate cards, not one banded row (Kai's design, 23 Sept): a tick at the top, the
    // reward's own name under it, and the threshold that earned it on its own line below a rule.
    // The tick leads because this view exists to confirm; the threshold is demoted to the footnote
    // it always was, but stays, because "all 3" still has to say what all 3 cost to reach.
    /* Kai's Option A (24 Sept), built from the canvas: the tick and the threshold share the top
       row of the tile, and the reward's name gets the whole second row to itself. The name is the
       SHORT half of the label — "Jouw cadeau", not "Cadeau naar keuze" — because one row is the
       requirement and the short half is what the metaobject keeps for exactly this kind of space.
       Measured at 390px: the longest short label is Dutch "Gratis verzending" at 91px against a
       95px tile, so it holds; anything longer a future campaign invents ellipsises rather than
       wrapping, which keeps the three tiles the same height whatever is in them. */
    var cells = state.TIERS.map(function(t){
      // Only tick what is genuinely secured, so an unchosen bracelet cannot read as done.
      var pending = (t.type === 'gift_choice') && !state.giftChosen;
      return '<div class="cr-band-cell' + (pending ? ' is-pending' : '') + '">'
        + '<span class="cr-band-top">'
          + '<i class="cr-band-tick" aria-hidden="true">' + (pending ? '!' : '&#10003;') + '</i>'
          + '<span class="cr-band-th">' + esc(thLabel(t.th)) + '</span>'
        + '</span>'
        + '<span class="cr-band-nm">' + esc(shortLabel(t.label)) + '</span>'
        + (pending ? '<span class="cr-band-sm">' + esc(T('not-chosen-yet', null, 'not chosen yet')) + '</span>' : '')
      + '</div>';
    }).join('');

    /* The sentence that used to trail the button now sits under the headline, where it answers
       the question the headline raises — "all 3, so where are they?" — instead of following the
       call to action, which is the last thing anyone reads. */
    var sub = gcPending
      ? esc(T('choose-before-checkout', null, 'Choose your reward before you check out'))
      : (worth ? esc(T('worth-already-in-cart', { amount: fmt(worth) },
                        'Worth ' + fmt(worth) + ' \u2014 already in your cart'))
               : esc(T('gifts-already-in-cart', null, 'Your gifts are already in the cart')));

    return '<div class="cr-won">'
      + '<div class="cr-won-head">'
        /* The eyebrow is gone and its job moved into the tick beside the headline (Option A): it
           was a third stacked line of text saying what the headline says, and on a phone that is
           the height the tiles want. */
        + '<span class="cr-won-hrow">'
          + '<span class="cr-won-h">' + esc(T('unlocked-all-n-rewards', { n: state.TIERS.length },
                'All ' + state.TIERS.length + ' rewards unlocked')) + '</span>'
        + '</span>'
        + '<span class="cr-won-sub">' + sub + '</span>'
      + '</div>'
      + '<div class="cr-wonband">' + cells + '</div>'
      + (gcPending
          ? '<button type="button" class="cr-cta cr-won-cta" data-cr-pickgift>' + esc(T('choose-your-reward', null, 'Choose your reward')) + '</button>'
          : '<a class="cr-cta cr-won-cta" href="/checkout">' + esc(T('proceed-to-checkout', null, 'Proceed to checkout')) + '</a>')
    + '</div>';
  }

  /* ---- Which arrangement the popup is in -------------------------------------------------------
     The default is an attribute written by snippets/cart-rewards-popup.liquid. A ?rewards= query
     overrides it and is remembered for the tab, so the three can be compared on one device without
     a push in between. The default is read ONCE and cached: paintModal writes the resolved value
     back onto the same attribute, which would otherwise overwrite what it was derived from. */
  var CR_LAYOUTS = { tiles:1, hero:1 }, crLayoutDefault = null, crLayoutPick = null;
  try {
    var crQ = (location.search.match(/[?&]rewards=([a-z]+)/i) || [])[1];
    if (crQ && CR_LAYOUTS[crQ.toLowerCase()]){
      crLayoutPick = crQ.toLowerCase();
      sessionStorage.setItem('ntfRewardsLayout', crLayoutPick);
    } else {
      crLayoutPick = sessionStorage.getItem('ntfRewardsLayout');
    }
    if (crLayoutPick && !CR_LAYOUTS[crLayoutPick]) crLayoutPick = null;
  } catch(e){ crLayoutPick = null; }
  function crLayout(){
    if (crLayoutDefault === null){
      var m = document.getElementById('cr-modal');
      if (!m) return crLayoutPick || 'tiles';
      var d = m.getAttribute('data-cr-layout');
      crLayoutDefault = CR_LAYOUTS[d] ? d : 'tiles';
    }
    return crLayoutPick || crLayoutDefault;
  }

  function paintModal(){
    if (!state) return;
    var crModalEl = document.getElementById('cr-modal');
    if (crModalEl) crModalEl.setAttribute('data-cr-layout', crLayout());
    if (crModalEl) crModalEl.style.visibility = '';
    var ni = nextIdx(state.value, state.TIERS);
    var dialog = document.querySelector('.cr-dialog');
    if (dialog) dialog.classList.toggle('cr-dialog--product', state.origin === 'product');
    if (dialog) dialog.setAttribute('data-cr-entry', state.origin === 'product' ? 'product' : 'cart');

    // Everything unlocked → show the celebration layout and collapse the two-column split.
    // The normal markup is HIDDEN, never replaced: removing an item can drop the cart back below
    // a threshold, and the ladder has to still be there when it does.
    var wonEl = document.getElementById('cr-won');
    var picking = false;   // every tier earned, the free gift still to choose
    if (ni === -1 && state.TIERS.length){
      /* Everything earned but the gift not picked yet: no "You earned all 3" screen with a button to
         press — straight to the four rewards in the picker, which says "You've unlocked all
         rewards" (Kai, 18 Sept). Only once the cart has been read (giftChosen === false), so a
         customer who already chose is never bounced into the picker. */
      var hasGiftTier = state.TIERS.some(function(t){ return t.type === 'gift_choice'; });
      /* Everything earned but the gift not picked yet: THIS page, with a View link on each gift
         (Kai, 25 Sept - one page from every door). This used to hand off to the picker's list, and
         the list now opens this page, so handing off would loop. Choosing happens on the gift's own
         page, which a card or its View link opens. */
      var giftPending = hasGiftTier && state.giftChosen === false;
      /* Not known yet: keep the dialog invisible for the moment the cart read takes, rather than
         flash the won screen and then swap to the picker. */
      if (hasGiftTier && state.giftChosen === undefined){
        if (crModalEl) crModalEl.style.visibility = 'hidden';
        return;
      }
      if (!giftPending){
        if (dialog){ dialog.classList.add('cr-dialog--won'); dialog.classList.remove('cr-dialog--pick'); }
        if (wonEl) wonEl.innerHTML = paintWon();
        var footEl = document.getElementById('cr-foot');
        if (footEl) footEl.innerHTML = '';
        return;
      }
      picking = true;
    }
    if (dialog) dialog.classList.remove('cr-dialog--won');
    /* Choosing the free gift hides the cart's "Explore picks for you" ending (CSS on this class,
       Kai 25 Sept): with every tier earned the page is about the gift, not more shopping. */
    if (dialog) dialog.classList.toggle('cr-dialog--pick', picking);
    if (wonEl) wonEl.innerHTML = '';

    if (picking) paintPick(); else paintA1(ni);
    /* The old Mix & match / Add-ons rail loaded here on every open - two requests for a rail the
       Explore sheet replaced. The sheet loads its tabs when it is opened. */
    paintEnd();
  }
  /* The ending under the shelf. Which one shows is CSS on data-cr-entry; only the cart ending has
     a line to fill: whose customers bought what (Kai: "Customers who bought XXX also bought:"). */
  function paintEnd(){
    var sub = document.getElementById('cr-end-sub');
    if (sub) sub.textContent = recsSubtitle('pair');
  }

  /* ---- A1 (2026-09-18) ------------------------------------------------------------------------
     The whole popup in one column, desktop and phone alike: the tier rail with each threshold on
     it, one headline for the next reward, then the reward shelf. It replaced the ladder, the hero,
     the chips, the side panel and the CTA rows — the rail says where the customer is, and the
     shelf is the reward itself, so none of those had anything left to say.
     The shelf reads the gift picker's own data (#gcp-modal[data-gc]), so both always offer the
     same rewards, and a card opens the picker on that reward's page. */
  function giftPool(){
    var m = document.getElementById('gcp-modal');
    if (!m) return null;
    try { return JSON.parse(m.getAttribute('data-gc') || '{}'); } catch(e){ return null; }
  }
  /* The gifts on offer, as cards: the bracelet collection is one card ("bundle"), like in the
     picker; each other gift is its own card. Read by the shelf (paintA1) and by the gift to choose
     (paintPick), so both always offer the same gifts at the same prices. */
  function giftCards(){
    var d = giftPool();
    if (!d) return [];
    var chosen = {};
    ((state && state.cartItems) || []).forEach(function(it){
      if (it.properties && it.properties._gift_choice) chosen[it.variant_id] = 1;
    });
    var cards = [], b = d.bundle;
    if (b && b.items && b.items.length){
      cards.push({ key:'bundle', img:(b.items[0].img || b.img || ''), price:b.items[0].price,
        name:(b.title || T('bundle-fallback-title', null, 'Beaded bracelet')),
        on:b.items.some(function(it){ return chosen[it.vid]; }) });
    }
    (d.gifts || []).forEach(function(g){
      /* The gift duplicates carry a " - <free>" suffix in their TRANSLATED titles ("Leren Reisetui -
         Gratis", "Reise-Etui aus Leder - Gratis", "Étui de Voyage en Cuir - Offert"); the card
         already says Free. French writes it "Offert", which this list lacked, so /fr kept the
         suffix. */
      cards.push({ key:String(g.vid), img:g.img, price:g.price, on:!!chosen[g.vid],
        name:String(g.title || '').replace(/\s*[-–]\s*(free|gratis|kostenlos|gratuite?|offerte?)\s*$/i, '') });
    });
    return cards;
  }
  /* The gift to choose (Kai, 25 Sept): every tier earned and no gift in the cart, so the page is
     only the gifts. The heading and "Continue without gift" are Liquid (cart-rewards-popup); this
     writes the line on what is already applied - the other tiers' own labels, joined in the
     visitor's language - and one card per gift. A card and its black button carry data-cr-gift,
     so they open the picker on that gift exactly as the shelf's cards do (the bracelet's colour and
     size, then "Choose this gift"). The picture half is a pointer convenience, hidden from screen
     readers: the button names the gift for them. */
  /* The gift grid, built in the background as soon as a claim banner shows (Kai, 25 Sept: "fix
     background grid load"). Building it when the page opened meant new pictures every time:
     measured 0/4 on screen when the page appeared, all four 50-110ms later, even with the files
     already fetched - the elements were new and still decoding. So the grid is built once, ahead,
     in idle time, its pictures fetched AND decoded (decode()), and the page reuses those elements:
     fillPickGrid() only rewrites the grid when its content has changed. */
  var pickWarmed = false;
  function warmPickPictures(){
    if (pickWarmed || !giftPool()) return;
    pickWarmed = true;
    (window.requestIdleCallback || function(f){ return setTimeout(f, 200); })(function(){
      var grid = fillPickGrid();
      if (!grid) return;
      grid.querySelectorAll('img').forEach(function(im){ if (im.decode) im.decode().catch(function(){}); });
    });
  }
  function fillPickGrid(){
    var grid = document.getElementById('cr-pick-grid');
    if (!grid) return null;
    var cards = giftCards();
    var html = cards.map(function(c){
      return '<div class="cr-pick-card">'
        + '<button type="button" class="cr-pick-open" data-cr-gift="' + esc(c.key) + '" tabindex="-1" aria-hidden="true">'
          + '<span class="cr-pick-img">'
            /* Not lazy: the cards are on screen the moment the page opens. */
            + (c.img ? '<img src="' + c.img + '" alt="" decoding="async">' : '')
          + '</span>'
          /* The name, then the price as a line of text under it - not a badge on the photo (Kai,
             25 Sept). */
          + '<span class="cr-pick-nm">' + esc(c.name) + '</span>'
          + '<span class="cr-pick-pr">' + (c.price ? '<s>' + fmt(c.price) + '</s> ' : '')
            + '<b>' + esc(T('free', null, 'Free')) + '</b></span>'
        + '</button>'
        + '<button type="button" class="button button-solid leading-normal justify-center pt-2.5 pb-2.5 md:pt-3 md:pb-3 cursor-pointer cr-pick-go"'
          + ' data-cr-gift="' + esc(c.key) + '" aria-label="' + esc(T('choose-x', { name: c.name }, 'Choose ' + c.name)) + '">'
          + '<span class="flex items-center justify-center">' + esc(T('choose', null, 'Choose')) + '</span>'
        + '</button>'
      + '</div>';
    }).join('');
    if (grid.__ntfHtml !== html){
      grid.innerHTML = html;
      grid.__ntfHtml = html;
      grid.setAttribute('data-cr-n', cards.length);
    }
    return grid;
  }
  /* The gift to choose (Kai, 25 Sept): every tier earned and no gift in the cart, so the page is
     only the gifts. The heading and "Continue without gift" are Liquid (cart-rewards-popup); this
     writes the line on what is already applied - the other tiers' own labels, joined in the
     visitor's language - and the grid (fillPickGrid, usually built ahead). A card and its black
     button carry data-cr-gift, so they open the picker on that gift exactly as the shelf's cards do
     (the bracelet's colour and size, then "Choose this gift"). The picture half is a pointer
     convenience, hidden from screen readers: the button names the gift for them. */
  function paintPick(){
    var sub = document.getElementById('cr-pick-sub');
    if (sub){
      var have = state.TIERS.filter(function(t){ return t.type !== 'gift_choice'; })
        .map(function(t){ return fullLabel(t.label); }).filter(Boolean);
      var list = have.length > 1
        ? have.slice(0, -1).join(', ') + ' ' + T('list-and', null, 'and') + ' ' + have[have.length - 1]
        : (have[0] || '');
      sub.textContent = !list ? '' : (have.length > 1
        ? T('pick-applied-many', { list: list }, list + ' are already applied.')
        : T('pick-applied-one', { list: list }, list + ' is already applied.'));
      if (sub.parentNode) sub.parentNode.hidden = !list;
    }
    fillPickGrid();
  }
  function paintA1(ni){
    var box = document.getElementById('cr-a1');
    var TT = state.TIERS;
    if (!box) return;
    if (!TT.length){ box.innerHTML = ''; return; }
    /* The nodes sit at EQUAL intervals, not at their thresholds (Kai, 2026-09-23). Money is not a
       distance: with tiers at 150 / 175 / 275 the first two landed 9% apart and the rail read as
       two dots stuck together and a straggler, which says nothing true about how far away each
       reward is. Three tiers are three steps, so they get a third of the rail each, whatever the
       amounts happen to be — and the amounts are printed inside the dots anyway. */
    var STEP = 100 / TT.length;

    /* The fill follows the same geometry, or it would stop short of a dot at the very moment that
       tier unlocked: complete steps, plus the fraction of the step the cart is part-way through.
       vFor() per tier, because the shipping tier ignores the order discount the others add back. */
    var fill = (function(){
      var prev = 0;
      for (var i = 0; i < TT.length; i++){
        var th = TT[i].th || 1, v = vFor(state.value, TT[i]);
        if (v < th){
          var span = (th - prev) || 1;
          return Math.max(0, Math.min(100, i * STEP + (v - prev) / span * STEP));
        }
        prev = th;
      }
      return 100;
    })();

    /* The last node is pinned to the end and right-aligned, since its label cannot hang past the
       edge of the popup. Full name on desktop, short name on a phone. */
    var nodes = TT.map(function(t, i){
      var un = unlocked(state.value, t), last = (i === TT.length - 1);
      var at = (i + 1) * STEP;
      return '<span class="cr-a1-node' + (un ? ' is-done' : '') + (last ? ' is-last' : '') + '"'
          + (last ? '' : ' style="left:' + at + '%"') + '>'
        /* The threshold lives INSIDE the circle (Kai, 2026-09-23): the dot is the milestone, so
           the money belongs in it, and the label under it is left saying only what you get. A
           done tier is green — the tick it used to carry would have to push the amount out. */
        + '<i class="cr-a1-dot" aria-hidden="true">' + (t.th < 100 ? '&#10003;' : esc(fmtRound(t.th))) + '</i>'
        + '<span class="cr-a1-lb"><span class="cr-a1-full">' + esc(fullLabel(t.label)) + '</span>'
          + '<span class="cr-a1-short">' + esc(shortLabel(t.label)) + '</span></span>'
      + '</span>';
    }).join('');

    /* The headline names what the shelf below IS, rather than repeating the distance (Kai,
       24 Sept). The chips above already show which tier is next and how far along the cart is, so
       "You're € 26 away from 10% off" said the same thing twice and pushed the gifts down. */
    /* "A gift of choice at €275+" (Kai, 25 Sept): the heading names the threshold of the gift tier
       itself, read from the campaign, so it moves when the campaign does. */
    var gcTier = TT.filter(function(t){ return t.type === 'gift_choice'; })[0];
    var head = '<h2 class="cr-a1-h">' + esc(gcTier
      ? T('a-gift-of-choice-at', { amount: fmtRound(gcTier.th) }, 'A gift of choice at ' + fmtRound(gcTier.th) + '+')
      : T('a-gift-of-choice', null, 'A gift of choice')) + '</h2>';
    /* Once the gift tier is unlocked, opened from the cart: a View link under each gift - the text
       button Kai asked for. The whole card already opens the gift's page; the link says so. */
    var showView = state.origin !== 'product' && !!gcTier && unlocked(state.value, gcTier);

    /* The shelf: only for a campaign with a reward to choose. */
    var shelf = '';
    var hasChoice = TT.some(function(t){ return t.type === 'gift_choice'; });
    var cards = hasChoice ? giftCards() : [];
    if (cards.length){
      /* The count goes on the element so CSS can decide between "they all fit" and "scroll".
         Three cards at a fixed 124px plus gaps overflow a phone, so the third was sliced down the
         middle by the dialog edge; as a grid of N equal columns they share whatever width there
         is and all three are whole. Only up to three — at four the columns would be too narrow to
         read, and a scroll shelf is the honest answer. */
      shelf = '<div class="cr-a1-shelf" data-cr-n="' + cards.length + '">' + cards.map(function(c){
        return '<div class="cr-a1-card' + (c.on ? ' is-on' : '') + '">'
          + '<button type="button" class="cr-a1-pick" data-cr-gift="' + esc(c.key) + '">'
            + (c.img ? '<img class="cr-a1-img" src="' + c.img + '" alt="" loading="lazy" decoding="async">'
                     : '<span class="cr-a1-img"></span>')
            + '<span class="cr-a1-nm">' + esc(c.name) + '</span>'
            + '<span class="cr-a1-pr">' + (c.price ? '<s>' + fmt(c.price) + '</s> ' : '')
              + '<b>' + esc(T('free', null, 'Free')) + '</b></span>'
            + (showView ? '<span class="cr-a1-view">' + esc(T('view', null, 'View')) + '</span>' : '')
          + '</button>'
          /* No "View details" button (Kai, 24 Sept): the whole card is already the same
             action — .cr-a1-pick wraps the image, the name and the price — so the button was a
             second control for one job, and it was the tallest part of the card. */
          + (c.on ? '<i class="cr-a1-ok" aria-hidden="true">&#10003;</i>' : '')
        + '</div>';
      }).join('') + '</div>';
    }
    /* Two renderings of the same ladder: the rail for desktop, and the drawer's own chip row for
       phones. CSS shows one and hides the other; nothing here decides, so a rotation or a resize
       needs no repaint. The chips are the fix for the labels colliding — three dots with three
       centred captions cannot hold "Kostenloser Versand" and "Prämie Ihrer Wahl" side by side on a
       330px track, while the chips ellipsis-clip and share the width by design. */
    box.innerHTML = '<div class="cr-a1-track"><span class="cr-a1-rail"><i style="width:' + fill + '%"></i></span>'
      + nodes + '</div>'
      + '<p class="cr-a1-nudge">' + headline(ni === -1 ? TT.length - 1 : ni, TT, state.value) + '</p>'
      + '<div class="cr-rchips cr-a1-chips"></div>'
      + head + shelf;
    var a1Chips = box.querySelector('.cr-a1-chips');
    if (a1Chips){ holdCount(a1Chips); paintChipRow(a1Chips, TT, state.value); }
  }

  // Thresholds read better without cents — "Tier 1: €75+" rather than "Spend € 75,00".
  /* A tier under one euro is "free with every order" (Halloween 2026: the bracelet tier is set at
     EUR 0.01 so any paid cart reaches it). Its threshold reads as words, never as "€ 0". */
  function thLabel(cents){
    return cents < 100 ? T('every-order', null, 'Every order') : fmtRound(cents);
  }
  function fmtRound(cents){
    var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) ? Shopify.currency.active : 'EUR';
    try {
      return new Intl.NumberFormat('nl-NL', { style:'currency', currency:cur,
        minimumFractionDigits:0, maximumFractionDigits:0 }).format(cents/100);
    } catch(e){ return Math.round(cents/100) + ' ' + cur; }
  }
  // Which tier the hero/side panel is showing. openIdx is null/-1 when nothing is expanded or
  // every tier is unlocked — fall back to the last reward rather than indexing TIERS[-1].
  function shownIdx(){
    var i = state.openIdx;
    if (i == null || i < 0 || !state.TIERS[i]) i = state.TIERS.length - 1;
    return i;
  }
  // A tier may carry a full gallery (`imgs`) once the metaobject references a product; until then
  // there is a single hand-uploaded `img`, and the strip simply collapses to one view.
  function imgsOf(t){
    var a = tierImgs(t).filter(Boolean);
    var one = tierImg(t);
    if (!a.length && one) a = [one];
    return a;
  }

  // Mobile hero: big image + thumbnail strip + the reward's copy.
  function paintHero(){
    var hero = document.getElementById('cr-hero');
    if (!hero || !state.TIERS.length) return;
    var i = shownIdx(), t = state.TIERS[i];
    if (!t){ hero.innerHTML = ''; return; }
    var imgs = imgsOf(t);
    var gi = state.gi || 0;
    if (gi >= imgs.length) gi = 0;
    var done = unlocked(state.value, t);

    /* No threshold on the picture. It lived there because it used to trail the title and pushed the
       name onto a second line; the tier tiles below carry it now — "€ 75+", "€ 175+", "€ 275+" —
       which is where the customer compares the three anyway. (.cr-hero-at-chip is left in the
       stylesheet, unused, so putting it back is one line.) */
    var media;
    if (!imgs.length){
      media = '<div class="cr-hero-main cr-hero-main--badge">' + esc(shortLabel(t.label)) + '</div>';
    } else {
      media = '<div class="cr-hero-main" style="background-image:url(' + imgs[gi] + ')">'
        /* A real image at its own ratio, so the frame follows the photo and nothing is cropped. The
           background stays as the fallback for the frame's colour while it loads. */
        + '<img class="cr-media-img" src="' + imgs[gi] + '" alt="" loading="lazy" decoding="async">'
        + (imgs.length > 1
            ? '<button type="button" class="cr-ga cr-ga--l" data-cr-gnav="-1" aria-label="' + esc(T('prev-image', null, 'Previous image')) + '">&lsaquo;</button>'
              + '<button type="button" class="cr-ga cr-ga--r" data-cr-gnav="1" aria-label="' + esc(T('next-image', null, 'Next image')) + '">&rsaquo;</button>'
            : '')
        + '</div>';
    }
    var thumbs = '';
    if (imgs.length > 1){
      thumbs = '<div class="cr-hero-thumbs">';
      imgs.forEach(function(im, k){
        thumbs += '<button type="button" class="cr-hero-th' + (k === gi ? ' is-on' : '') + '"'
          + ' data-cr-gdot="' + k + '" style="background-image:url(' + im + ')"'
          + ' aria-label="' + esc(T('view-x', { title: (k+1) }, 'View ' + (k+1))) + '"></button>';
      });
      thumbs += '</div>';
    }
    hero.innerHTML = media + thumbs
      + '<div class="cr-hero-body">'
        /* Threshold joins the title instead of taking a line of its own. "Tier 1" was our word for
           it, not the customer's — the number is the part that means anything, and on a phone that
           line cost as much height as the description. Kept a separate colour so the reward and
           the price to reach it stay distinguishable at a glance. */
        + '<div class="cr-hero-tt">' + esc(fullLabel(t.label)) + '</div>'
        + (t.desc ? '<div class="cr-hero-ds">' + esc(t.desc) + '</div>' : '')
        + '<span class="cr-hero-bar"><i style="width:' + tierPct(t.th, vFor(state.value, t)) + '%"></i></span>'
        + '<div class="cr-hero-st' + (done ? ' is-done' : '') + '">'
          + (done ? '&#10003; ' + esc(T('unlocked', null, 'Unlocked')) : esc(toGo(t.th - vFor(state.value, t))))
        + '</div>'
        /* The gift tier is the only one whose reward is not a single photograph, so the panel
           cannot show it: "Reward of your choice" names something the customer has no way to
           look at. This opens the real picker in browse mode. */
        + (t.type === 'gift_choice' && !done
          ? '<button type="button" class="cr-cta cr-cta--ghost cr-viewall" data-cr-viewrewards>' + esc(T('view-all-rewards', null, 'View all rewards')) + ' &rsaquo;</button>'
          : '')
      + '</div>';
  }

  // Stepping through images repaints only the two gallery surfaces — not the tier list and not
  // the upsells, which would re-fetch.
  function paintGalleries(){
    paintHero();
    paintSide(nextIdx(state.value, state.TIERS));
  }

  // Mobile tier ladder — a progress rail with one cell per tier beneath it.
  //
  // The earned tier used to be a solid green cell with white-on-green text, which made the reward
  // the customer had ALREADY collected the loudest thing on the panel — louder than the one they
  // were working towards. Earned is now marked by a small tick and a green threshold; the weight
  // is spent on the rail, which is the only part that shows how far along they actually are.
  function paintChips(){
    var box = document.getElementById('cr-chips');
    if (!box) return;
    var sel = shownIdx();
    // The fill moves continuously, but the MARKERS are the anchors. The cells are evenly spaced
    // thirds, so a single value/topThreshold ramp put the bar in the wrong segment: at 75 of 275 it
    // sat at 27% — still inside step 1 — while step 1 was already earned and ticked.
    // Each segment is therefore mapped to its own third: 0 -> 0%, th1 -> exactly 33%, th2 -> 66%,
    // th3 -> 100%, interpolated in between. The bar is a fraction of the way to the NEXT stop, and
    // an earned stop always has the bar at or past its marker, whatever the thresholds are.
    var n = state.TIERS.length, seg = n ? 100 / n : 0, pct = 100, v = state.value;
    for (var pi = 0; pi < n; pi++) {
      var lo = pi ? state.TIERS[pi - 1].th : 0, hi = state.TIERS[pi].th;
      if (v < hi) { pct = seg * (pi + (hi > lo ? (v - lo) / (hi - lo) : 1)); break; }
    }
    pct = Math.max(0, Math.min(100, pct));

    var cells = '';
    state.TIERS.forEach(function(t, i){
      var un = unlocked(state.value, t);
      // is-done = earned, is-on = the tier currently shown in the hero. They are NOT the same
      // thing: an earlier version tinted on is-on, so the highlight followed the selection
      // instead of what had actually been unlocked.
      /* Each cell carries its OWN progress, measured inside that tier's band: 0% until the cart
         passes the tier below it, 100% once it clears this one. With a single shared rail the
         second and third cells were simply blank until the first tier was earned, which reads as
         two bars that failed to draw rather than as two rewards still to come. */
      cells += '<button type="button" class="cr-chip' + (un ? ' is-done' : '') + (i === sel ? ' is-on' : '') + '"'
        + ' data-cr-tier="' + i + '" aria-pressed="' + (i === sel ? 'true' : 'false') + '">'
        + (un ? '<i class="cr-chip-ok" aria-hidden="true">&#10003;</i>' : '')
        /* "€ 75+", not "€ 75": the tile is a threshold you cross, not a price. This is the only
           place the threshold is stated now that the picture no longer carries a corner chip. */
        + '<span class="cr-chip-d">' + fmtRound(t.th) + '+</span>'
        + '<span class="cr-chip-l">' + esc(fullLabel(t.label)) + '</span>'
      + '</button>';
    });

    /* No second rail. The hero above already draws progress for the tier on screen, and two green
       bars a few pixels apart read as two different measurements of the same thing. The cells keep
       their own earned/selected tint, which is what actually tells you where you are. */
    box.innerHTML = '<span class="cr-chips-cells">' + cells + '</span>';
  }

  // viewIdx is the tier currently on screen in the side panel. Without it the button was always
  // about the GLOBAL next tier, so standing on an already-unlocked "Free beaded bracelet" panel
  // the button read "Add € 57,00 more" — an amount belonging to the travel case two tiers down,
  // with nothing on screen to connect it to. The button now either concerns the tier you are
  // looking at, or names the reward it is actually about.
  // Casing note: .cr-cta applies text-transform:uppercase, so the strings stay sentence case.
  // Where "Add € X more" sends the customer. Same destination as the empty-cart tiles and the
  // earned-tier CTA, so every "go and shop" route in the cart lands in one place and is changed
  // in one setting.
  function shopUrl(){
    return (window.NTF_CART_CONFIG && window.NTF_CART_CONFIG.continueShopping) || '/collections/all';
  }

  /* The popup's footer: back to where they came from, or on to the shop. Both are links so a
     long-press still offers "open in new tab", and Back to cart simply closes the popup — the
     cart is the surface underneath it. */
  function footPair(){
    /* From the product page there is nowhere to send them but back to it. */
    if (state && state.origin === 'product'){
      return '<div class="cr-footpair cr-footpair--one">'
        +  '<button type="button" class="cr-cta cr-cta--ghost" data-cr-close>' + esc(T('go-back', null, 'Go back')) + '</button>'
        +  '</div>';
    }
    var url = (window.NTF_CART_CONFIG && window.NTF_CART_CONFIG.continueShopping) || '/collections/all';
    return '<div class="cr-footpair">'
      +  '<button type="button" class="cr-cta cr-cta--ghost" data-cr-close>' + esc(T('back-to-cart', null, 'Back to cart')) + '</button>'
      +  '<a class="cr-cta" href="' + url + '">' + esc(T('shop-all', null, 'Shop all')) + '</a>'
      +  '</div>';
  }
  function ctaHtml(ni, viewIdx){
    // A gift_choice tier that is unlocked but UNCLAIMED has a different job to "spend more":
    // pick the bracelet. Checked FIRST — an earlier version of this sat after the return and was
    // dead code. Only ever true for gift-choice campaigns; tiers campaigns have no such type.
    var gcIdx = -1;
    state.TIERS.forEach(function(t, i){
      if (t.type === 'gift_choice' && unlocked(state.value, t)) gcIdx = i;
    });
    if (gcIdx !== -1 && !state.giftChosen){
      return '<button type="button" class="cr-cta" data-cr-pickgift>' + esc(T('choose-your-reward', null, 'Choose your reward')) + '</button>';
    }
    if (ni === -1) return '<a class="cr-cta" href="/checkout">' + esc(T('proceed-to-checkout', null, 'Proceed to checkout')) + '</a>';

    var viewed = (viewIdx == null) ? null : state.TIERS[viewIdx];
    // Looking at a tier you have not reached: the button is simply that tier's own gap, which is
    // the same figure the panel prints as "€ X to go" directly above it.
    if (viewed && state.value < viewed.th){
      // A link, not a scroll. This used to jump to the upsell strip lower down the same panel,
      // which on a short list did nothing visible at all — the customer pressed the main CTA and
      // the popup simply sat there. Sending them to the shop is the action the label promises.
      /* Two buttons, not one. "Add EUR 6 more" was the only control on the screen, so the customer
         who just wanted to go back to their cart had to hunt for the close cross — and the amount
         is already printed directly above this, on the tier itself. Back to cart is the quiet one
         because it is the safe exit; Continue shopping carries the weight, since it is the action
         that actually earns the reward. */
      return footPair();
    }
    // Looking at something already earned. Naming the next reward here ("Add € 22,00 more for
    // travel case") pushed a DIFFERENT tier at a customer who is reading about one they have
    // already won, and the longer string wrapped to two lines in the side panel. The honest action
    // on an earned reward is simply to carry on browsing.
    return footPair();
  }

  // Desktop side panel: whichever tier is selected (defaults to the next one), featured large.
  function paintSide(ni){
    var side = document.getElementById('cr-side');
    if (!side) return;
    /* The row exists at every width but is display:none below the desktop breakpoint, where the
       mobile footer carries the CTA — so ask the layout, not the viewport. */
    var ctaRowEl = document.getElementById('cr-ctarow');
    var ctaRow = (ctaRowEl && getComputedStyle(ctaRowEl).display !== 'none') ? ctaRowEl : null;
    if (ctaRowEl && !ctaRow) ctaRowEl.innerHTML = '';
    // openIdx is -1 when every tier is unlocked — fall back to the last reward rather than
    // indexing TIERS[-1] (which is undefined and used to throw, so the popup never opened).
    var i = state.openIdx;
    if (i == null || i < 0 || !state.TIERS[i]) i = state.TIERS.length - 1;
    var t = state.TIERS[i];
    if (!t) { side.innerHTML = ''; return; }
    var done = unlocked(state.value, t);
    // Same gallery as the mobile hero: the linked product's full image set, with ‹ › and a
    // thumbnail strip. Falls back to the single uploaded photo, then to a label tile.
    var imgs = imgsOf(t);
    var gi = state.gi || 0;
    if (gi >= imgs.length) gi = 0;
    // The strip only exists for a tier with a gallery. Rendered conditionally it made the
    // whole dialog grow and shrink when switching tiers, because 38px of thumbnails plus their
    // margin appeared and disappeared. An empty placeholder of the same height keeps the panel a
    // constant size, which is what the customer expects when clicking between rewards.
    var media, strip = '<span class="cr-side-thumbs cr-side-thumbs--empty"></span>';
    if (!imgs.length){
      media = '<span class="cr-side-media cr-side-media--badge">' + esc(shortLabel(t.label)) + '</span>';
    } else {
      media = '<span class="cr-side-media" style="background-image:url(' + imgs[gi] + ')">'
        + '<img class="cr-media-img" src="' + imgs[gi] + '" alt="" loading="lazy" decoding="async">'
        + (imgs.length > 1
            ? '<button type="button" class="cr-ga cr-ga--l" data-cr-gnav="-1" aria-label="' + esc(T('prev-image', null, 'Previous image')) + '">&lsaquo;</button>'
              + '<button type="button" class="cr-ga cr-ga--r" data-cr-gnav="1" aria-label="' + esc(T('next-image', null, 'Next image')) + '">&rsaquo;</button>'
            : '')
        + '</span>';
      if (imgs.length > 1){
        strip = '<span class="cr-side-thumbs">';
        imgs.forEach(function(im, k){
          strip += '<button type="button" class="cr-side-thumb' + (k === gi ? ' is-on' : '') + '"'
            + ' data-cr-gdot="' + k + '" style="background-image:url(' + im + ')"'
            + ' aria-label="' + esc(T('view-x', { title: (k+1) }, 'View ' + (k+1))) + '"></button>';
        });
        strip += '</span>';
      }
    }
    side.innerHTML =
      '<div class="cr-side-lbl">' + esc(done ? T('unlocked', null, 'Unlocked')
            : (i === ni ? T('next-reward', null, 'Next reward')
                        : T('reward-n', { n: (i+1) }, 'Reward ' + (i+1)))) + '</div>'
      + media + strip
      + '<div class="cr-side-tt">' + esc(fullLabel(t.label)) + '</div>'
      + '<div class="cr-side-th">' + esc(T('tier-n', { n: (i+1) }, 'Tier ' + (i+1))) + ': ' + fmtRound(t.th) + '+</div>'
      + (t.desc ? '<div class="cr-side-ds">' + esc(t.desc) + '</div>' : '')
      /* From ZERO, not from the previous tier: a bar answers "how far along am I", and measured
         within its own band tier 3 read as empty on a cart that is two-thirds of the way there.
         Same measure the mobile popup uses. segPct still drives the drawer chips, where each chip
         is one band and that is exactly what it should show. */
      + '<span class="cr-side-bar"><i style="width:' + tierPct(t.th, vFor(state.value, t)) + '%"></i></span>'
      + '<div class="cr-side-st' + (done ? ' is-done' : '') + '">'
        + (done ? '\u2713 ' + esc(T('unlocked', null, 'Unlocked')) : esc(toGo(t.th - vFor(state.value, t))))
      + '</div>'
      + (t.type === 'gift_choice' && !done
        ? '<button type="button" class="cr-cta cr-cta--ghost cr-viewall" data-cr-viewrewards>' + esc(T('view-all-rewards', null, 'View all rewards')) + ' &rsaquo;</button>'
        : '')
      /* The CTA lives under the products on desktop, in its own full-width row. It stays in the
         panel wherever that row is not laid out, so no width loses its call to action. */
      + (ctaRow ? '' : ctaHtml(ni, i));
    if (ctaRow) ctaRow.innerHTML = ctaHtml(ni, i);
  }

  // Mobile footer: just the CTA (the side panel carries it on desktop).
  // Passes the OPEN tier as the viewed one — on mobile the hero shows that tier, so it plays the
  // same role the side panel does on desktop. Without it ctaHtml sees no viewed tier, takes the
  // "already earned" branch every time, and the mobile footer would only ever offer "Continue
  // shopping" — never prompting toward the next reward.
  function paintFoot(ni){
    var foot = document.getElementById('cr-foot');
    if (foot) foot.innerHTML = ctaHtml(ni, (state && state.openIdx != null) ? state.openIdx : ni);
  }

  // Keep service/utility SKUs out of the upsells: gift cards, and the legacy Zepto
  // "Gift Box Personalization" product (superseded by the built-in personalizer).
  var SKIP = /(gift\s*card|e-?gift|personalization|personalisation|personalisatie|personalisierung|personnalisation)/i;
  function isUpsellable(p){
    if (!p || !p.title) return false;
    if (SKIP.test(p.title)) return false;
    if (p.product_type && /gift\s*card/i.test(p.product_type)) return false;
    return true;
  }

  function cardsHtml(items){
    var h = '';
    items.forEach(function(p){
      var img = p.featured_image || (p.images && p.images[0]) || '';
      var single = p.variants && p.variants.length === 1 && p.variants[0].available;
      h += '<div class="cr-rec">'
        + '<a href="' + p.url + '" class="cr-rec-link">'
          + '<span class="cr-rec-img" style="background-image:url(' + img + '&width=300)"></span>'
          + '<span class="cr-rec-t">' + esc(p.title) + '</span>'
          + '<span class="cr-rec-p">' + fmt(p.price) + '</span>'
        + '</a>'
        + (single
            ? '<button type="button" class="cr-rec-btn" data-cr-add="' + p.variants[0].id + '">' + esc(T('add', null, 'Add')) + '</button>'
            : '<a class="cr-rec-btn" href="' + p.url + '">' + esc(T('choose', null, 'Choose')) + '</a>')
      + '</div>';
    });
    return h;
  }

  /* The short name a customer actually calls the piece: "Aswad - Matt Black Beaded Bracelet 6mm"
     is the catalogue title, "Aswad" is the name. Everything before the first dash. */
  function shortTitle(t){
    t = String(t || '').split(' - ')[0].split(' – ')[0].trim();
    return t.length > 26 ? t.slice(0, 25).trim() + '…' : t;
  }
  /* One line under the tabs saying whose recommendation this is. With a single item it can name
     the piece, which is the version that reads as a recommendation rather than as an ad; with
     several there is no single "also bought", so it speaks about the basket instead. */
  function recsSubtitle(tab){
    if (tab === 'easy') return T('recs-addons', null, 'Quick add ons and must-haves.');
    /* Read the CART, not the drawer's DOM. The popup can be open over the cart page, or over a
       drawer that has since been closed, and then the row selector matched nothing and the whole
       sentence silently disappeared — which is exactly how it went missing. state.cartTitles is
       filled from /cart.js, which is loaded for the recommendations anyway. */
    var names = [], seen = {};
    var titles = state.cartTitles || [];
    for (var i = 0; i < titles.length; i++) {
      var n = shortTitle(titles[i]);
      // Gift-box and free-gift lines are not something a customer "bought", so they never
      // become the subject of the sentence — they are already left out of cartTitles by their
      // properties (see loadRecs), not here by the words "gift box" in a title.
      if (!n || seen[n]) continue;
      seen[n] = 1; names.push(n);
    }
    if (names.length === 1) return T('recs-bought-one', { product: names[0] }, 'Frequently worn with ' + names[0] + '.');
    if (names.length > 1)  return T('recs-bought-many', null, 'Frequently worn with these designs.');
    return '';
  }
  function paintRecs(){
    var wrap = document.getElementById('cr-recs');
    var track = document.getElementById('cr-recs-track');
    if (!wrap || !track) return;
    var tab = state.recsTab || 'pair';
    var sub = document.getElementById('cr-recs-sub');
    if (sub) {
      var txt = recsSubtitle(tab);
      if (sub.textContent !== txt) sub.textContent = txt;
      sub.hidden = !txt;
    }
    var htmlOf = function(t){ return t === 'easy' ? state.easyHtml : state.recsHtml; };
    var other = tab === 'easy' ? 'pair' : 'easy';

    // "To pair with your cart" is seeded from the first cart item, so on an EMPTY cart it has
    // nothing to pair with and resolves to ''. It was still the default tab, so the popup opened
    // on a dead panel reading "Nothing to show here right now" while the other tab had products.
    // A tab that resolved to nothing is never the one we land on, and its button is hidden — an
    // empty tab the customer can click is worse than no tab.
    // '' means "loaded and genuinely empty"; null means "not loaded yet" and must not trigger this.
    if (htmlOf(tab) === '' && htmlOf(other) !== ''){
      state.recsTab = tab = other;
      if (htmlOf(other) == null && !state.recsSwitching){
        state.recsSwitching = true;                 // loadEasy/loadRecs call paintRecs on entry
        (other === 'easy' ? loadEasy : loadRecs)();
        state.recsSwitching = false;
      }
    }

    wrap.querySelectorAll('[data-cr-tab]').forEach(function(b){
      b.classList.toggle('is-on', b.dataset.crTab === tab);
      b.hidden = htmlOf(b.dataset.crTab) === '';
    });
    var html = htmlOf(tab);
    if (html == null){
      track.innerHTML = '<div class="cr-recs-empty">' + esc(T('loading', null, 'Loading\u2026')) + '</div>';
    } else if (html === '') {
      track.innerHTML = '<div class="cr-recs-empty">' + esc(T('recs-empty', null, 'Nothing to show here right now.')) + '</div>';
    } else if (track.innerHTML !== html) {
      track.innerHTML = html;
    }
    wrap.hidden = false;
  }

  // Tab 1 — "To pair with your cart", seeded from the first cart item.
  //
  // Prefers intent=complementary, which serves the picks merchandisers curate in the Search &
  // Discovery app (stored on each product as the metafield
  // shopify--discovery--product_recommendation.complementary_products). Those are hand-chosen
  // "goes with this" products, which is exactly what this tab claims to be.
  //
  // Products without curated picks fall back to intent=related — Shopify's algorithmic
  // "similar to this" — so the tab is never empty. Related is topped up behind complementary
  // when there are fewer than four curated picks, deduped by product id.
  function recsFor(id, intent){
    return fetch('/recommendations/products.json?product_id=' + id + '&limit=8&intent=' + intent,
      { headers:{ Accept:'application/json' } })
      .then(function(r){ return r.ok ? r.json() : { products: [] }; })
      .then(function(d){ return d.products || []; })
      .catch(function(){ return []; });
  }
  /* "A gift, not a purchase": properties and price are the same in every language (rule 1).
     Shared by the ending's "Customers who bought X" line and the Explore sheet's seed. */
  function isGiftLineItem(it){
    var p = (it && it.properties) || {};
    return !!(p._gift || p._free_gift || p._gift_choice || p._Gifted || p._auto_gift) || (it && it.price === 0);
  }
  /* The product the basket is built around: the dearest real line, as the old rail seeded it. */
  function seedProductId(items){
    var real = (items || []).filter(function(it){
      return !isGiftLineItem(it) && isUpsellable({ title: it.product_title || it.title });
    }).sort(function(a, b){ return (b.price || 0) - (a.price || 0); });
    if (real.length) return real[0].product_id;
    return (items && items[0]) ? items[0].product_id : null;
  }

  /* ---- The Explore sheet (Kai, 25 Sept) ----------------------------------------------------------
     "Explore picks for you" slides this over the page. Its grid is sections/ntf-picks.liquid - the
     collection page's own grid and card snippet - fetched through the Section Rendering API from
     Shopify.routes.root, so the cards come back in the visitor's language and currency. (The old
     rail read /products.json without the locale prefix, and was English everywhere.)
     Mix & match: Shopify's recommendations for the product the basket is built around, curated
     (complementary) first and algorithmic (related) when there are none. Add-ons: the
     ntf_easy_add_collection setting, cheapest first. Each tab loads once per opening of the popup. */
  var EX = { tab: 'pair', html: {}, busy: {} };
  function exRoot(){ return (window.Shopify && Shopify.routes && Shopify.routes.root) || '/'; }
  function exFetch(url){
    return fetch(url, { headers:{ Accept:'text/html' } })
      .then(function(r){ return r.ok ? r.text() : ''; })
      .catch(function(){ return ''; });
  }
  function exHasCards(h){ return !!h && h.indexOf('data-ntf-picks-empty') === -1 && h.indexOf('grid-item') !== -1; }
  function exLoad(tab){
    if (EX.html[tab] != null || EX.busy[tab]) return;
    EX.busy[tab] = true;
    var p;
    if (tab === 'easy'){
      var h = (window.NTF_CART_CONFIG && window.NTF_CART_CONFIG.easyAddCollection) || 'all';
      var coll = function(handle){
        return exFetch(exRoot() + 'collections/' + encodeURIComponent(handle) + '?section_id=ntf-picks&sort_by=price-ascending');
      };
      /* An unpublished collection answers 200 with nothing in it, so an empty grid falls back too. */
      p = coll(h).then(function(html){ return (exHasCards(html) || h === 'all') ? html : coll('all'); });
    } else {
      /* The cart may not have been read yet - the sheet can now open in the same moment as the popup
         - so the seed waits for it. An empty cart on a product page seeds from that product. */
      var items = (state && state.cartItems)
        ? Promise.resolve(state.cartItems)
        : fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
            .then(function(r){ return r.json(); }).then(function(c){ return c.items || []; })
            .catch(function(){ return []; });
      p = items.then(function(list){
        var meta = window.ShopifyAnalytics && ShopifyAnalytics.meta && ShopifyAnalytics.meta.product;
        var id = seedProductId(list) || (meta && meta.id) || null;
        if (!id) return '';
        var rec = function(intent){
          return exFetch(exRoot() + 'recommendations/products?product_id=' + id + '&limit=12&intent=' + intent + '&section_id=ntf-picks');
        };
        return rec('complementary').then(function(html){ return exHasCards(html) ? html : rec('related'); });
      });
    }
    p.then(function(html){
      EX.html[tab] = html || ''; EX.busy[tab] = false; exPaint();
      /* Built in the background, so the tap only slides it in (Kai, 25 Sept: "Explore picks for you"
         took ~320ms on a phone-speed CPU, nearly all of it laying out the grid the moment the sheet
         left display:none). */
      (window.requestIdleCallback || function(f){ return setTimeout(f, 60); })(exPark);
    });
  }
  function exPaint(){
    var sheet = document.getElementById('cr-ex');
    if (!sheet) return;
    sheet.querySelectorAll('[data-cr-ex-tab]').forEach(function(t){
      var on = t.getAttribute('data-cr-ex-tab') === EX.tab;
      t.classList.toggle('opacity-80', !on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      var lb = t.querySelector('.label-ntf-ex');
      if (lb) lb.classList.toggle('active', on);
    });
    var sub = document.getElementById('cr-ex-sub');
    if (sub) sub.textContent = recsSubtitle(EX.tab);
    var body = document.getElementById('cr-ex-body');
    if (!body) return;
    var html = EX.html[EX.tab], tpl;
    if (html == null){
      tpl = sheet.querySelector('[data-cr-ex-wait]');
      body.innerHTML = tpl ? tpl.outerHTML : '';
      exLoad(EX.tab);
      return;
    }
    /* Nothing came back at all (a failed request): the empty line. An EMPTY GRID is different - the
       section already says so itself and still carries "Explore all", so it is painted as is. */
    if (!html){
      tpl = sheet.querySelector('[data-cr-ex-empty]');
      body.innerHTML = tpl ? tpl.outerHTML : '';
      return;
    }
    body.innerHTML = html;
    body.scrollTop = 0;
  }
  /* Park the loaded sheet: laid out, but hidden and off to the right of the dialog, which clips it
     (overflow-x:hidden - Fix 7). display:none (.is-gone) kept the browser from building it at all, so
     the whole grid was laid out inside the tap. Parked, opening is a transform the compositor runs.
     Only while the popup is open and the sheet closed; exClose() puts .is-gone back as before. */
  function exPark(){
    var m = document.getElementById('cr-modal'), s = document.getElementById('cr-ex');
    var d = m && m.querySelector('.cr-dialog');
    if (!m || !s || !d || m.style.display !== 'flex' || d.classList.contains('is-exploring')) return;
    s.classList.remove('is-gone');
  }
  function exOpen(){
    var d = document.querySelector('#cr-modal .cr-dialog');
    if (!d) return;
    d.scrollTop = 0;
    var s = document.getElementById('cr-ex');
    if (s){ s.classList.remove('is-gone'); void s.offsetWidth; s.setAttribute('aria-hidden', 'false'); }
    d.classList.add('is-exploring');
    var mo = document.getElementById('cr-modal');
    if (mo) mo.classList.add('ntf-exploring');   // phones: the sheet is a full-screen page (CSS)
    exPaint();
    /* And the other tab behind it, so switching to Add-ons is instant too. */
    setTimeout(function(){ exLoad(EX.tab === 'easy' ? 'pair' : 'easy'); }, 500);
  }
  function exClose(){
    var d = document.querySelector('#cr-modal .cr-dialog');
    if (d) d.classList.remove('is-exploring');
    var mo = document.getElementById('cr-modal');
    if (mo) mo.classList.remove('ntf-exploring');
    var s = document.getElementById('cr-ex');
    if (s) s.setAttribute('aria-hidden', 'true');
    /* Out of the page once it has slid away (Kai, 25 Sept: "the popup shows 2 random products").
       Parked off to the right it still held its cards; the theme's card images force themselves
       visible, so they showed through the sheet's visibility:hidden - and the dialog could be
       scrolled sideways onto them. display:none after the 300ms slide leaves nothing to show. */
    setTimeout(function(){
      if (s && !(d && d.classList.contains('is-exploring'))) s.classList.add('is-gone');
    }, 320);
  }

  function loadRecs(){
    paintRecs();
    if (state.recsHtml != null || state.recsLoading) return;
    state.recsLoading = true;
    fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        if (!cart.items || !cart.items.length) throw new Error('empty cart');
        var isGiftLine = function(it){
          var p = it.properties || {};
          return !!(p._gift || p._free_gift || p._gift_choice || p._Gifted || p._auto_gift) || it.price === 0;
        };
        // Titles for the subtitle under the tabs; free gifts carry a _flag property and are not
        // something the customer chose, so they never name the sentence.
        /* One test for "a gift, not a purchase": the same one that picks the seeds below. The
           subtitle used to leave out the gift box by finding the words "gift box" in its title —
           English words, which a translated title ("Geschenkbox", "Boîte cadeau gratuite") does
           not contain (engineering rule 1). Properties and price are the same in every language. */
        state.cartTitles = cart.items.filter(function(it){ return !isGiftLine(it); })
          .map(function(it){ return it.product_title || it.title; });
        paintRecs();
        /* Seed from what the customer CHOSE, not from cart.items[0].
           The first line is regularly the free gift box, a free bracelet or the travel case —
           added by us, not picked by them. Shopify has no recommendations for those, so the tab
           resolved to '' and paintRecs hid it: the drawer then showed "Add-ons" alone, with the
           whole "Mix & match" half of the row gone (reported 2026-09-23).
           So: drop the gifts and service SKUs, take the dearest real piece first — it is the one
           the basket is really built around — and walk down the list until a seed actually
           returns something. Capped at three seeds so a big cart cannot fan out into requests.
           isGiftLine is defined above, shared with the subtitle. */
        var seeds = cart.items
          .filter(function(it){ return !isGiftLine(it) && isUpsellable({ title: it.product_title || it.title }); })
          .sort(function(a, b){ return (b.price || 0) - (a.price || 0); })
          .map(function(it){ return it.product_id; })
          .filter(function(id, i, all){ return all.indexOf(id) === i; })
          .slice(0, 3);
        if (!seeds.length) seeds = [ cart.items[0].product_id ];   // gift-only cart: better than nothing

        var inCart = state.cartProductIds || [];
        var seen = {};
        var keep = function(p){
          if (!p || !p.available || seen[p.id]) return false;
          if (inCart.indexOf(p.id) !== -1) return false;
          if (!isUpsellable(p)) return false;
          seen[p.id] = 1;
          return true;
        };
        var trySeed = function(i){
          if (i >= seeds.length) return Promise.resolve([]);
          return Promise.all([ recsFor(seeds[i], 'complementary'), recsFor(seeds[i], 'related') ])
            .then(function(pair){
              seen = {};                                  // each seed is judged on its own
              var curated = pair[0].filter(keep);
              var items = curated.length >= 4 ? curated : curated.concat(pair[1].filter(keep));
              return items.length ? items : trySeed(i + 1);
            });
        };
        return trySeed(0);
      })
      .then(function(items){
        state.recsHtml = cardsHtml(items.slice(0, 8));
      })
      .catch(function(){ state.recsHtml = ''; })
      .then(function(){ state.recsLoading = false; paintRecs(); });
  }

  // Tab 2 — "Easy to add": the cheapest available products, so a customer can top up to the
  // next tier without much thought. Pulls from the collection named in the theme setting
  // `ntf_easy_add_collection`, falling back to /collections/all, then sorts by price ascending.
  function loadEasy(){
    paintRecs();
    if (state.easyHtml != null || state.easyLoading) return;
    state.easyLoading = true;
    var handle = (window.NTF_CART_CONFIG && window.NTF_CART_CONFIG.easyAddCollection) || 'all';
    // Fall back to /collections/all rather than leaving the tab blank — cheapest-first still
    // gives a usable list, and an empty tab looks broken with no way to tell why.
    // NOTE: a collection that is not published to the Online Store channel does NOT 404 — it
    // answers 200 with an empty `products` array. So an empty result has to trigger the fallback
    // just like a bad status does; checking r.ok alone silently yields an empty tab.
    function grab(h){
      return fetch('/collections/' + h + '/products.json?limit=250', { headers:{ Accept:'application/json' } })
        .then(function(r){ if (!r.ok) throw new Error('no collection: ' + h); return r.json(); })
        .then(function(d){
          if (h !== 'all' && !(d.products && d.products.length)){
            throw new Error('collection "' + h + '" returned no products (is it published to the Online Store?)');
          }
          return d;
        });
    }
    grab(handle)
      .catch(function(err){
        if (handle === 'all') throw err;
        if (window.console) console.warn('[rewards] ' + err.message + ' — falling back to all products');
        return grab('all');
      })
      .then(function(data){
        var inCart = state.cartProductIds || [];
        var items = (data.products || [])
          .filter(isUpsellable)
          .map(function(p){
            var v = (p.variants || []).filter(function(x){ return x.available; })[0];
            if (!v) return null;
            return { id:p.id, title:p.title, url:'/products/' + p.handle,
                     price: Math.round(parseFloat(v.price) * 100),
                     featured_image: (p.images && p.images[0] && p.images[0].src) || '',
                     variants: [{ id:v.id, available:true }], available:true };
          })
          .filter(function(p){ return p && inCart.indexOf(p.id) === -1; })
          .sort(function(a,b){ return a.price - b.price; })
          .slice(0, 8);
        state.easyHtml = cardsHtml(items);
      })
      .catch(function(){ state.easyHtml = ''; })
      .then(function(){ state.easyLoading = false; paintRecs(); });
  }

  function loadTab(){ return (state.recsTab === 'easy') ? loadEasy() : loadRecs(); }

  /* Warm both tabs while the drawer is open, so the popup has them in hand. Guarded on state, so a
     second drawer open costs nothing; the loaders already return early once loaded or loading. */
  var warmed = false;
  function warmRecs(){
    if (warmed || !state || !state.TIERS || !state.TIERS.length) return;
    warmed = true;
    var go = function(){
      try { loadRecs(); loadEasy(); } catch (e) {}
    };
    if (window.requestIdleCallback) window.requestIdleCallback(go, { timeout: 1500 });
    else setTimeout(go, 600);
  }
  /* The drawer opening is the signal. The theme fires its own event; the mutation pass is the
     backstop for the cart page, where there is no drawer to open. */
  document.addEventListener('eurus:cart-drawer:open', warmRecs);
  document.addEventListener('eurus:cart:items-changed', function(){ warmed = false; });
  if (window.NTF_ON_MUTATE) window.NTF_ON_MUTATE(function(){
    /* Flag first, then the drawer's open CLASS - not getBoundingClientRect(), which forced a layout
       on every DOM change for a warm-up that runs once (25 Sept: up to 494ms a pass on a
       phone-speed CPU). Only once the drawer is open: warming behind a closed drawer spends a
       request on a customer who may never open it. */
    if (warmed) return;
    var d = document.getElementById('CartDrawer');
    if (d && d.classList.contains('cart-open')) warmRecs();
  });

  // Has the customer already picked their bracelet? Drives whether the CTA offers the picker.
  function syncGiftChosen(){
    return fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        rememberCart(cart);
        var n = 0;
        (cart.items || []).forEach(function(it){
          if (it.properties && it.properties._gift_choice) n += it.quantity;
        });
        if (state) state.giftChosen = n > 0;
        return n;
      }).catch(function(){ return 0; });
  }
  document.addEventListener('ntf:gift-chosen-changed', function(){
    // Full repaint, not just the footer: the all-unlocked view in the BODY also branches on
    // giftChosen, and repainting only the foot left it contradicting itself.
    syncGiftChosen().then(function(){ if (state) paintModal(); });
  });

  /* Remembered so the picker's "Back to rewards" can put this popup back exactly as it was. A
     live row is preferred when one exists — the cart may have moved on. */
  var lastRow = null, lastOrigin = null;

  /* ...and which TIER it was showing. "Back to rewards" used to land on whichever tier was next
     unearned, because openPopup recomputes openIdx on every open — so leaving from the third tier
     via "View all rewards" came back to free shipping. Captured only while the popup is actually on
     screen: the picker also opens from the product banner and the drawer's claim strip, where a
     leftover value would restore a tier nobody was looking at. Consumed once, so an ordinary open
     still starts on the next reward.
     Registered BEFORE the closePopup listener below, which is what hides the modal — reading
     display afterwards would always say none. */
  var lastOpenIdx = null, lastGi = 0;
  document.addEventListener('ntf:open-gift-picker', function(){
    var m = document.getElementById('cr-modal');
    if (state && m && m.style.display === 'flex'){
      lastOpenIdx = state.openIdx;
      lastGi = state.gi || 0;
    }
  });

  /* Where the last tap landed. A door that goes THROUGH the picker - the product page's gift
     banner, the drawer's claim strip - reaches the popup as an event with no element, so this is
     how the popup learns which surface it was opened on. */
  var lastTap = { el: null, t: 0 };
  document.addEventListener('click', function(e){ lastTap = { el: e.target, t: Date.now() }; }, true);

  document.addEventListener('ntf:open-rewards-popup', function(e){
    var d = (e && e.detail) || {};
    /* A door that went through the picker opens the popup for the surface the TAP was on (Kai,
       25 Sept: from the product page it showed the cart ending - "Ready to continue shopping?" -
       because the remembered row was the drawer's, from an earlier opening). Back from a gift's page
       and the locked "Spend X more" button are different: they return to the popup as it was, so
       they keep the remembered row below. */
    if (d.fromList){
      var tap = (Date.now() - lastTap.t < 3000 && lastTap.el && lastTap.el.isConnected) ? lastTap.el : null;
      var inDrawer = !!(tap && tap.closest && tap.closest('#CartDrawer, #x-cart-drawer-container'));
      var prodRow0 = document.querySelector('.ntf-osec--product [data-cr-row]');
      var pick = null;
      if (inDrawer){
        pick = tap.closest('[data-cr-row]');
        if (!pick) document.querySelectorAll('#CartDrawer [data-cr-row], #x-cart-drawer-container [data-cr-row]').forEach(function(r){ if (!pick) pick = r; });
      } else if (prodRow0){
        pick = prodRow0;
      }
      if (pick){ openPopup(pick, null); lastOpenIdx = null; return; }
    }
    /* Come back to the surface the customer actually left from. On a product page BOTH rows exist —
       the page's own and the cart drawer's, rendered by theme.liquid ahead of it — so neither one
       can be preferred on sight: preferring the product row sent someone who had opened the popup
       from the CART DRAWER back to the stripped product version, with no rails and no cart footer,
       and preferring the first row in the document did the mirror of that on a product page.
       The row the popup was opened from is the answer, while it is still in the document; the
       drawer re-renders through the Section Rendering API and replaces it, so the remembered ORIGIN
       is the fallback, and only then the old guess. */
    var row = (lastRow && lastRow.isConnected) ? lastRow : null;
    if (!row){
      var prodRow = document.querySelector('.ntf-osec--product [data-cr-row]'), cartRow = null;
      document.querySelectorAll('[data-cr-row]').forEach(function(r){
        if (!cartRow && !(r.closest && r.closest('.ntf-osec--product'))) cartRow = r;
      });
      row = (lastOrigin === 'cart') ? (cartRow || prodRow) : (prodRow || cartRow);
    }
    if (row){
      openPopup(row, lastOpenIdx);
      /* Straight onto the picks and add-ons: the gift page's "Spend X more to unlock" asks for this. */
      if (e && e.detail && e.detail.explore) exOpen();
    }
    lastOpenIdx = null;
  });
  function openPopup(row, restoreIdx){
    var dlgCk = document.querySelector('#cr-modal .cr-dialog');
    if (dlgCk) dlgCk.classList.remove('cr-dialog--checkout');
    lastRow = row;
    var tiers = getTiers(row), val = +row.dataset.value;
    curOrderDisc = +row.dataset.orderDisc || 0;
    var n = nextIdx(val, tiers);
    /* Where this popup was opened from. On the product page it is a reference, not a shopping
       surface — the rails and the cart/shop footer would pull the customer off the product. */
    var origin = (row.closest && row.closest('.ntf-osec--product')) ? 'product' : 'cart';
    lastOrigin = origin;   // survives the row itself, which a drawer re-render replaces
    /* Coming back from the picker, the tier the customer left from — checked against the CURRENT
       tiers, since the cart can have moved on while they were in there. Otherwise the next reward;
       when everything is unlocked, the last one. */
    var back = (restoreIdx != null && tiers[restoreIdx]) ? restoreIdx : null;
    state = { TIERS: tiers, value: val, pay: +row.dataset.pay || val, origin: origin,
              openIdx: (back != null) ? back : ((n === -1) ? tiers.length - 1 : n),
              gi: (back != null) ? lastGi : 0, recsTab: 'pair' };
    if (lastCart){ state.cartTitles = cartTitlesOf(lastCart); state.cartItems = lastCart.items; }
    /* Every opening fills its chips from empty, once the popup has arrived; a repaint during the
       same opening continues instead of restarting (see paintChipRow). */
    delete FILL_MEM.popup;
    // One cart read seeds everything the popup needs, INCLUDING whether the gift has been
    // chosen. giftChosen was previously only set by the ntf:gift-chosen-changed event, so on first
    // open it was undefined — which reads as "not chosen" and made the all-unlocked view demand a
    // bracelet the customer had already picked.
    fetch(cartJsUrl(), { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(c){
        rememberCart(c);
        state.cartProductIds = (c.items||[]).map(function(i){ return i.product_id; });
        state.cartItems = c.items||[];
        state.cartTitles = cartTitlesOf(c);
        paintEnd();
        var n = 0;
        (c.items||[]).forEach(function(it){
          if (it.properties && it.properties._gift_choice) n += it.quantity;
        });
        var was = state.giftChosen;
        state.giftChosen = n > 0;
        /* Trust the CART, not the attribute. data-value is written by Liquid when the surface is
           rendered, and a surface can outlive the cart it was rendered for — the drawer most of
           all, which theme.liquid prints once on page load. Open the popup from a row that was
           printed while the cart was empty and the whole ladder read "€75,00 to go … €275,00 to go"
           over a full cart, with a CTA to spend more (Kai, 2026-09-23). The figures come from the
           same two lines refreshRows() uses, so both paths agree.
           The row is corrected too, so closing and reopening does not resurrect the stale number. */
        var f = cartFigures(c);
        var moved = (f.value !== state.value) || (f.orderDisc !== curOrderDisc);
        if (moved){
          state.value = f.value;
          state.pay = f.pay;
          curOrderDisc = f.orderDisc;
          if (row && row.isConnected){
            row.dataset.value = f.value;
            row.dataset.orderDisc = f.orderDisc;
            row.dataset.pay = f.pay;
            row.dataset.view = defaultView(f.value, getTiers(row));
            if (row.classList.contains('ntf-strip')) paintStrip(row); else paintRow(row);
          }
        }
        if (moved || was !== state.giftChosen) paintModal();   // repaint once the truth is known
        /* Opened by the checkout gate, but the cart says there is no gift to choose after all (a
           banner painted before the cart changed): on to checkout, as if the gate were not there. */
        if (ckBtn){
          var dCk = document.querySelector('#cr-modal .cr-dialog');
          if (!dCk || !dCk.classList.contains('cr-dialog--pick')) goCheckout();
        }
      })
      /* Cart unreadable: show the won screen as before (null, not undefined, so it is not held
         invisible waiting for an answer that will never come). */
      .catch(function(){
        if (ckBtn){ goCheckout(); return; }   // never hold a checkout on an unreadable cart
        if (state.giftChosen === undefined){ state.giftChosen = null; paintModal(); }
      });
    EX = { tab: 'pair', html: {}, busy: {} };
    exClose();
    paintModal();
    /* The picks start loading while the customer is still looking at the gifts (Kai, 25 Sept,
       Fix 11: "sneakily start preloading"), so "Explore picks for you" usually opens onto cards.
       Only for the cart's ending - the product page's has no such button - and a beat after the
       popup, so its own images are not queued behind the picks. */
    var dlgEntry = document.querySelector('#cr-modal .cr-dialog');
    if (dlgEntry && dlgEntry.getAttribute('data-cr-entry') === 'cart'){
      /* Not once every tier is earned: the ending is hidden then (the gift still to choose, or the
         won screen), so nothing could open the picks. Checked when the timer fires, since the cart
         read may have corrected the value by then; if the cart drops below a tier later, the button
         comes back and exOpen() loads the picks itself. */
      setTimeout(function(){ if (state && nextIdx(state.value, state.TIERS) !== -1) exLoad('pair'); }, 350);
    }
    var modal = document.getElementById('cr-modal');
    // last in DOM order, so the drawer's overlay can never sit on top of it
    document.body.appendChild(modal);
    var wasOpen = modal.style.display === 'flex';
    modal.style.display = 'flex';
    /* Arrives, not appears (Kai, 25 Sept, Fix 4: "it just spawns in your face") - the theme's own
       popup entrance, see .ntf-pop-in in ntf-cart.css. Only on a real opening. */
    if (!wasOpen){
      modal.__ntfOpenedAt = Date.now();
      modal.classList.remove('ntf-pop-in'); void modal.offsetWidth; modal.classList.add('ntf-pop-in');
    }
    modal.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closePopup(){
    ckBtn = null;
    var modal = document.getElementById('cr-modal');
    if (!modal) return;
    var dlgCk = modal.querySelector('.cr-dialog');
    if (dlgCk) dlgCk.classList.remove('cr-dialog--checkout');
    exClose();
    modal.style.display = 'none';
    modal.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  /* ---- Checkout with the free gift still to choose (Kai, 25 Sept) --------------------------------
     "If someone has not chosen a gift and clicks on checkout, can you show the popup. Just hide the
     sentence, you can always choose it later." A click on a checkout button while a claim banner
     shows (every tier earned, no gift in the cart) opens the gift page first, without its note
     (.cr-dialog--checkout). "Continue without gift" then goes on to checkout by clicking the SAME
     button again, so the theme's own handler (goToCheckout, the terms box, the form) runs as it
     always does. Closing with the X stays in the cart; the next checkout click asks again. Capture
     phase, so this runs before the button's own Alpine handler. */
  var ckBtn = null, ckPass = false;
  /* The row to open the page for: one whose gift tier is reached, while the cart holds no gift. Not
     the claim banner's class - the cart page's banner row (cart-progress-bar) has no banner, so it
     never carries it. gcChosenCount is read from the cart on every page; unknown (null) lets the
     checkout go ahead rather than hold it. */
  function claimRowFor(btn){
    if (gcChosenCount !== 0) return null;
    var scope = btn.closest('#CartDrawer, #x-cart-drawer-container');
    var rows = (scope || document).querySelectorAll('[data-cr-row]');
    for (var i = 0; i < rows.length; i++){
      var r = rows[i];
      if (r.closest('.ntf-osec--product')) continue;
      var TT = getTiers(r), v = +r.dataset.value || 0;
      if (TT.some(function(t){ return t.type === 'gift_choice' && unlocked(v, t); })) return r;
    }
    return null;
  }
  function goCheckout(){
    var b = ckBtn;
    closePopup();
    if (b && b.isConnected){ ckPass = true; b.click(); }
  }
  document.addEventListener('click', function(e){
    var btn = e.target.closest && e.target.closest('button[name="checkout"]');
    if (!btn || btn.disabled) return;
    if (ckPass){ ckPass = false; return; }
    var row = claimRowFor(btn);
    if (!row) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    openPopup(row);
    ckBtn = btn;
    var d = document.querySelector('#cr-modal .cr-dialog');
    if (d) d.classList.add('cr-dialog--checkout');
  }, true);

  // The bracelet picker is a SEPARATE dialog and must be the only thing on screen. Both modals
  // carry z-index 2147483647, so with the rewards popup left open underneath they simply stacked:
  // on desktop the picker happens to cover it and the bug is invisible, but on mobile the two are
  // different sizes and the customer sees the tier ladder bleeding around the picker.
  // Closing here rather than inside the click handler catches every entry point — the popup CTA,
  // the all-unlocked CTA and the drawer claim banner. Harmless when no popup is open.
  // Runs before the picker's own listener resolves (that one awaits a cart read), so the picker
  // sets body overflow after this clears it, not the other way round.
  /* Any panel's close control shuts the <details> that opened it, which runs the toggle handler
     above and takes the sheet back down with its animation. */
  document.addEventListener('click', function(e){
    var x = e.target.closest && e.target.closest('[data-ntf-panel-close]');
    if (!x) return;
    e.preventDefault();
    var pan = x.closest('.ntf-fpanel');
    var kind = pan && pan.classList.contains('ntf-fpanel--note') ? 'note' : 'deliv';
    var det = document.querySelector('.ntf-fdet--' + kind);
    if (det) det.open = false;
  });
  document.addEventListener('ntf:open-gift-picker', closePopup);

  /* Cart PAGE, phone: the rewards row goes above the products, where the drawer keeps it. It is
     rendered inside the order card (below the list); on a phone it is moved, and moved again after
     every Section-Rendering refresh puts a fresh copy back in the card. Desktop keeps the card. */
  function placeRewardsRow(){
    var main = document.getElementById('main-cart-items'); if (!main) return;
    var row = main.querySelector('.ntf-order-card .ntf-osec--rewards'); var table = main.querySelector('table.cart-items');
    if (!row || !table) return;
    if (window.innerWidth < 768){
      if (!row.__ntfHome) row.__ntfHome = { parent: row.parentNode, next: row.nextSibling };
      row.classList.add('ntf-osec--rewards-top');
      table.parentNode.insertBefore(row, table);
    }
  }
  /* ---- Cart PAGE, phone: the drawer's pinned footer ------------------------------------------
     Moves the gift box, the note/delivery row (with its panels), the checkout block and the trust
     strip into one fixed dock at the bottom of the viewport. Rebuilt after every Section-Rendering
     refresh, and undone above 768px. */
  function dockUnits(card){
    var out = [];
    var gift = card.querySelector('.gbp-cta');
    if (gift) out.push(gift.closest('.ntf-osec') || gift);
    var frow = card.querySelector('.ntf-frow');
    if (frow) out.push(frow);
    /* The panels travel with the row that opens them, so an open note or delivery sheet is still
       attached to its summary. The delivery panel teleports to <body> when it becomes a drawer and
       remembers where it came from — that home is simply the dock now. */
    [].slice.call(card.querySelectorAll('.ntf-fpanel')).forEach(function(p){ out.push(p); });
    var co = card.querySelector('#checkout-submit');
    if (co) out.push(co.parentElement);          // checkout + dynamic buttons + payment icons
    /* The strip itself, NOT its parent: its parent is .ntf-osec--main, which also holds the
       totals — taking it docked the money and emptied the order card. */
    var trust = card.querySelector('.ntf-trust');
    if (trust) out.push(trust);
    /* Belt and braces: the money scrolls in layout 6, so nothing containing it may be docked. */
    var money = card.querySelector('#js-contents');
    return out.filter(function(el, i, a){
      if (!el || a.indexOf(el) !== i) return false;
      if (money && (el === money || el.contains(money))) return false;
      return true;
    });
  }
  var dockRO = null;
  function undock(dock){
    document.body.style.paddingBottom = '';
    document.documentElement.style.removeProperty('--ntf-dock-h');
    if (dockRO){ dockRO.disconnect(); dockRO = null; }
    [].slice.call(dock.children).forEach(function(el){
      var h = el.__ntfDockHome;
      if (h && h.parent && h.parent.isConnected){
        /* The remembered sibling was very likely docked too, so it is no longer a child of this
           parent — insertBefore would throw and abandon the rest of the restore. */
        var ref = (h.next && h.next.parentNode === h.parent) ? h.next : null;
        h.parent.insertBefore(el, ref);
      }
      else if (el.parentNode) el.parentNode.removeChild(el);
    });
    if (dock.parentNode) dock.parentNode.removeChild(dock);
    document.body.style.paddingBottom = '';
    setHtmlFlag('ntf-has-dock', false);
  }
  /* State flags on <html>, set only when the state CHANGES, for CSS that must react to something
     elsewhere in the page (25 Sept). These replace body:has(...) rules whose subject was a
     class-substring such as [class*="launcher" i]: Chrome re-evaluates a :has() on <body> for DOM
     insertions anywhere, and with a substring subject it then re-checks every element that carries
     a class - measured on a 4x-throttled phone as ~1,860 elements restyled, 270-300ms, three times
     for a single tap on the rewards row. A class on <html> costs that once, when the state flips. */
  function setHtmlFlag(c, on){
    var h = document.documentElement.classList;
    if (h.contains(c) !== !!on) h.toggle(c, !!on);
  }
  function syncOverlayFlags(){
    var d = document.getElementById('CartDrawer');
    setHtmlFlag('ntf-drawer-open', !!(d && d.classList.contains('cart-open')));
    setHtmlFlag('ntf-gbp-open', !!document.querySelector('.gbp-overlay.gbp-open'));
  }
  function dockCartFooter(){
    var main = document.getElementById('main-cart-items'); if (!main) return;
    var card = main.querySelector('.ntf-order-card'); if (!card) return;
    var dock = document.getElementById('ntf-cart-dock');
    if (window.innerWidth >= 768){ if (dock) undock(dock); return; }
    /* A checkout button still inside the card means nothing is docked yet, or a cart refresh has
       just put a fresh copy back — either way, rebuild from what is in the card now. */
    if (!card.querySelector('#checkout-submit')) return;
    if (!dock){
      dock = document.createElement('div');
      dock.id = 'ntf-cart-dock'; dock.className = 'ntf-cart-dock';
      document.body.appendChild(dock);
    } else {
      undock(dock);
      dock = document.createElement('div');
      dock.id = 'ntf-cart-dock'; dock.className = 'ntf-cart-dock';
      document.body.appendChild(dock);
    }
    dockUnits(card).forEach(function(el){
      if (!el.__ntfDockHome) el.__ntfDockHome = { parent: el.parentNode, next: el.nextSibling };
      dock.appendChild(el);
    });
    if (!dock.children.length){ undock(dock); return; }
    setHtmlFlag('ntf-has-dock', true);
    /* The page must be able to scroll clear of the dock, and the dock's height changes when a
       panel opens or the gift box flips to its done state. */
    /* The dock's height is published as a variable so anything else anchored to the bottom of the
       viewport — a live-chat bubble, a cookie bar — can sit above it rather than on top of it. */
    var pad = function(){
      var h = Math.round(dock.getBoundingClientRect().height);
      document.body.style.paddingBottom = h + 'px';
      document.documentElement.style.setProperty('--ntf-dock-h', h + 'px');
    };
    pad();
    if (window.ResizeObserver){ if (dockRO) dockRO.disconnect(); dockRO = new ResizeObserver(pad); dockRO.observe(dock); }
  }
  placeRewardsRow();
  dockCartFooter();
  document.addEventListener('eurus:cart:items-changed', function(){ setTimeout(dockCartFooter, 350); });
  document.addEventListener('cart:updated', function(){ setTimeout(dockCartFooter, 350); });
  window.addEventListener('resize', dockCartFooter);
  if (window.NTF_ON_MUTATE) NTF_ON_MUTATE(dockCartFooter);
  if (window.NTF_ON_MUTATE) NTF_ON_MUTATE(syncOverlayFlags);
  syncOverlayFlags();
  document.addEventListener('eurus:cart:items-changed', function(){ setTimeout(placeRewardsRow, 300); });
  document.addEventListener('cart:updated', function(){ setTimeout(placeRewardsRow, 300); });
  if (window.NTF_ON_MUTATE) NTF_ON_MUTATE(placeRewardsRow);


  // (The cart icon guard now lives INLINE in layout/theme.liquid. It has to register before
  //  this file executes: this one is deferred, and a tap landing before it ran was exactly
  //  the case it was meant to catch.)


  /* The delivery disclosure is a drawer now, and a drawer opens at the top. Opening it focuses the
     summary, and the browser scrolls the newly fixed panel to bring that focus into view — which
     starts a full-height drawer halfway down with its title clipped. */
  document.addEventListener('toggle', function(e){
    var det = e.target;
    if (!det.classList) return;
    /* Both rows behave the same now: the note is a bottom sheet over a dim, exactly as the
       delivery panel is, because that is what the drawer does with both. */
    var kind = det.classList.contains('ntf-fdet--deliv') ? 'deliv'
             : det.classList.contains('ntf-fdet--note') ? 'note' : '';
    if (!kind) return;
    var panel = document.querySelector('.ntf-fpanel--' + kind);
    var scrim = document.querySelector('.ntf-deliv-scrim');
    if (det.open){
      /* A real scrim, appended to <body> so nothing on the page can out-stack it. */
      if (!scrim){
        scrim = document.createElement('div');
        scrim.className = 'ntf-deliv-scrim';
        scrim.addEventListener('click', function(){ det.open = false; });
        document.body.appendChild(scrim);
      }
      if (panel){
        /* Out of the page and onto <body>. Inside the summary card its z-index was capped by an
           ancestor's stacking context, which is why it opened under the header and the
           announcement bar. Where it came from is remembered so it can go back. */
        if (!panel.__ntfHome){
          panel.__ntfHome = { parent: panel.parentNode, next: panel.nextSibling };
        }
        if (panel.__ntfCloseTimer){ clearTimeout(panel.__ntfCloseTimer); panel.__ntfCloseTimer = null; }
        document.body.appendChild(panel);
        panel.classList.add('is-drawer');
        requestAnimationFrame(function(){ panel.scrollTop = 0; });
      }
      /* Two frames between existing and opening, so the transform actually transitions — the
         same 300ms the cart drawer takes. */
      requestAnimationFrame(function(){ requestAnimationFrame(function(){
        if (panel) panel.classList.add('is-open');
        var sc = document.querySelector('.ntf-deliv-scrim'); if (sc) sc.classList.add('is-open');
      }); });
    } else {
      /* The same 300ms back out before anything is removed or put back. */
      if (scrim) scrim.classList.remove('is-open');
      if (panel) panel.classList.remove('is-open');
      var done = function(){
        var sc2 = document.querySelector('.ntf-deliv-scrim');
        if (sc2 && sc2.parentNode) sc2.parentNode.removeChild(sc2);
        if (panel){
          panel.classList.remove('is-drawer');
          var home = panel.__ntfHome;
          if (home && home.parent) home.parent.insertBefore(panel, home.next);
          panel.__ntfCloseTimer = null;
        }
      };
      if (panel) panel.__ntfCloseTimer = setTimeout(done, 300); else done();
    }
  }, true);

  // ---- Delegated events ----
  document.addEventListener('click', function(e){
    // Upsell tab switch: "To pair with your cart" vs "Easy to add"
    var tabBtn = e.target.closest('[data-cr-tab]');
    if (tabBtn && state){
      state.recsTab = tabBtn.dataset.crTab;
      loadTab();
      return;
    }
    // "I understand" in the cart-page delivery panel — collapse the disclosure.
    if (e.target.closest('[data-ntf-deliv-close]')){
      var dd = document.querySelector('.ntf-fdet--deliv');
      if (dd) dd.open = false;
      return;
    }
    // A click outside the open delivery drawer closes it. The scrim behind it is a pseudo-element
    // and cannot receive a click of its own, so the document does the work: anything that is
    // neither inside the panel nor the summary that opened it counts as outside.
    /* Anything outside the drawer closes it. The scrim has its own listener; this covers a click
       that lands on something above it, such as the header. */
    var openDeliv = document.querySelector('.ntf-fdet--deliv[open]');
    if (openDeliv
        && !e.target.closest('.ntf-fpanel--deliv')
        && !e.target.closest('.ntf-fdet--deliv')){
      openDeliv.open = false;
      return;
    }
    /* A1 shelf: a reward card, or its "View details", opens the picker on that reward. Browse mode
       until the reward tier is reached, so nothing is added to a cart that has not earned it. */
    var giftBtn = e.target.closest('[data-cr-gift]');
    if (giftBtn){
      e.preventDefault();
      var gcT = state && state.TIERS.filter(function(t){ return t.type === 'gift_choice'; })[0];
      document.dispatchEvent(new CustomEvent('ntf:open-gift-picker', { detail:{
        preview: !(gcT && unlocked(state.value, gcT)), from:'rewards',
        open: giftBtn.getAttribute('data-cr-gift') } }));
      return;
    }
    // "Add €X more" — reveal / scroll to the recommendations rather than navigating away.
    if (e.target.closest('[data-cr-pickgift]')){
      e.preventDefault();
      document.dispatchEvent(new CustomEvent('ntf:open-gift-picker', { detail:{ from:'rewards' } }));
      return;
    }
    /* Same picker, browse mode. It closes this popup (see the listener above) and reopens it when
       the customer comes back, rather than stacking two dialogs — on a phone the two are different
       sizes and the ladder bled around the picker. */
    if (e.target.closest('[data-cr-viewrewards]')){
      e.preventDefault();
      /* from: the picker's footer depends on where the customer came from. Arriving here they can
         only go back to the tiers, so one button says so; arriving from the product banner they
         want their product back, and the tiers are the second, optional door. */
      document.dispatchEvent(new CustomEvent('ntf:open-gift-picker',
        { detail:{ preview:true, from:'rewards' } }));
      return;
    }
    var scrollBtn = e.target.closest('[data-cr-scroll]');
    if (scrollBtn){
      var recs = document.getElementById('cr-recs');
      if (recs && !recs.hidden){
        // On desktop the recommendations are already fully visible, so scrollIntoView did nothing
        // and the button read as dead. Scroll only when it is actually off-screen, and flash it
        // either way so the click always produces visible feedback.
        var r = recs.getBoundingClientRect();
        var offscreen = r.top < 0 || r.bottom > (window.innerHeight || 0);
        if (offscreen) recs.scrollIntoView({ behavior:'smooth', block:'nearest' });
        recs.classList.remove('cr-recs-flash');
        void recs.offsetWidth;                    // restart the animation
        recs.classList.add('cr-recs-flash');
        setTimeout(function(){ recs.classList.remove('cr-recs-flash'); }, 1400);
      }
      return;
    }
    // Quick-add a recommended single-variant product straight into the cart.
    //
    // Uses the theme's own add-and-re-render flow (pass `sections`, then reRenderSections) rather
    // than reloading the page. A reload threw the customer back to whatever page they were on
    // with the drawer closed, which read as "it sent me to the homepage" — the whole point of the
    // upsell is that they stay in the cart and watch the reward bar move.
    var addBtn = e.target.closest('[data-cr-add]');
    if (addBtn){
      var vid = addBtn.dataset.crAdd;
      addBtn.disabled = true; addBtn.textContent = T('adding', null, 'Adding\u2026');
      var sectionIds = [];
      try {
        sectionIds = Alpine.store('xCartHelper').getSectionsToRender().map(function(s){ return s.id; });
      } catch(err){ /* Alpine not ready — the add still works, the drawer just repaints later */ }
      fetch('/cart/add.js', {
        method:'POST',
        headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body: JSON.stringify({ items:[{ id:+vid, quantity:1 }], sections: sectionIds })
      }).then(function(r){ return r.json(); })
        .then(function(res){
          if (res && res.status == '422') throw new Error(res.description || 'add failed');
          try { Alpine.store('xCartHelper').reRenderSections(res.sections); } catch(err){}
          try { Alpine.store('xCartHelper').currentItemCount =
            parseInt(document.getElementById('cart-icon-bubble').innerHTML); } catch(err){}
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          addBtn.textContent = T('added', null, 'Added \u2713');
          // Close, and let the cart speak. Repainting in place was the cause of the stacked
          // screens: crossing a threshold swapped the panel to the all-unlocked view while the
          // ordinary ladder was still rendered below it. Closing is also what the customer
          // expects — they just added something, so the cart is what they want to see, and the
          // claim banner there is what tells them to choose their bracelet.
          // Delayed so "Added" is readable before the panel goes.
          setTimeout(function(){
            closePopup();
            // Open the drawer if it is not already showing, so closing is not a dead end.
            // Harmless on the cart page, where the cart is the page.
            try { Alpine.store('xMiniCart').openCart(); } catch(err){}
          }, 450);
        })
        .catch(function(){
          addBtn.disabled = false; addBtn.textContent = T('add', null, 'Add');
        });
      return;
    }
    // Mobile hero gallery: ‹ › arrows and the thumbnail strip. Only the hero repaints, so tapping
    // through images never rebuilds the list or re-fetches the upsells.
    var gnav = e.target.closest('[data-cr-gnav]');
    if (gnav && state){
      var gt = state.TIERS[shownIdx()];
      var n = gt ? (imgsOf(gt).length || 1) : 1;
      state.gi = ((state.gi || 0) + (+gnav.dataset.crGnav) + n) % n;
      paintGalleries();
      return;
    }
    var gdot = e.target.closest('[data-cr-gdot]');
    if (gdot && state){
      state.gi = +gdot.dataset.crGdot;
      paintGalleries();
      return;
    }
    // Expand/collapse a tier inside the popup (works for unlocked tiers too, so a customer
    // can open "Free Bracelet" or "10% OFF" and read what's included).
    var tierBtn = e.target.closest('[data-cr-tier]');
    if (tierBtn && state){
      var ti = +tierBtn.dataset.crTier;
      /* Every tier, the gift tier included, SELECTS here — the panel shows that tier's own info,
         and the panel's "View all rewards" button is the door to the four gifts. Sending the tap
         straight to the picker skipped the tier the customer had just asked about. */
      // A chip SELECTS a reward — collapsing it would leave the mobile hero with nothing chosen.
      // The desktop ladder rows keep their toggle behaviour.
      state.openIdx = tierBtn.classList.contains('cr-chip')
        ? ti
        : ((state.openIdx === ti) ? null : ti);
      state.gi = 0;                       // new reward, start its gallery at the first image
      paintModal();
      return;
    }
    var nav = e.target.closest('.cr-arrow');
    if (nav){
      var row = nav.closest('[data-cr-row]');
      if (!row) return;
      var TIERS = getTiers(row);
      var view = (+row.dataset.view + (+nav.dataset.crNav) + TIERS.length) % TIERS.length;
      row.dataset.view = view;
      paintRow(row);
      return;
    }
    /* Before the row opener: the chip sits inside [data-cr-open], whose default is the ladder. A
       tap on the gift chip means the rewards. */
    /* (The gift chip used to open the picker's list here. It sits inside [data-cr-open], so it now
       falls through to it and opens the one page for its own row - Kai, 25 Sept: "no matter where
       you click it just shows the same page".) */
    var openEl = e.target.closest('[data-cr-open]');
    if (openEl){
      var row2 = openEl.closest('[data-cr-row]');
      if (!row2) return;
      openPopup(row2);
      return;
    }
    if (e.target.closest('[data-cr-explore]')){ e.preventDefault(); exOpen(); return; }
    if (e.target.closest('[data-cr-ex-back]')){ e.preventDefault(); exClose(); return; }
    var exTab = e.target.closest('[data-cr-ex-tab]');
    if (exTab){ e.preventDefault(); EX.tab = exTab.getAttribute('data-cr-ex-tab'); exPaint(); return; }
    if (e.target.closest('#cr-close')){ closePopup(); return; }
    // The footer's "Back to cart" does the same thing as the cross: the cart is the surface
    // this popup opened on top of.
    if (ckBtn && e.target.closest('.cr-pick-skip')){ goCheckout(); return; }
    if (e.target.closest('[data-cr-close]')){ closePopup(); return; }
    if (e.target.id === 'cr-modal'){ closePopup(); return; }
  });
  window.addEventListener('keydown', function(e){ if (e.key === 'Escape') closePopup(); });

  // Re-scan whenever the drawer content is (re)inserted (cart-page banner is scanned once on load).
  scanRows();
  syncDelivery();
  paintFreeFrom();
  paintFee();
  // the estimate line is populated by the theme's own script, so retry briefly
  var delTries = 0;
  var delTimer = setInterval(function(){
    delTries++; syncDelivery();
    var d = document.querySelector('.ntf-fdet--deliv');
    if ((d && !d.hidden) || delTries > 60) clearInterval(delTimer);
  }, 300);
  var mount = document.getElementById('x-cart-drawer-container');
  if (mount) {
    // the drawer is lazy-rendered, so re-run both when its contents appear/refresh.
    // Debounced, and the callbacks below only write when values actually change — both
    // guards matter, since these paint into the very subtree being observed.
    var moTimer = null;
    new MutationObserver(function(){
      clearTimeout(moTimer);
      moTimer = setTimeout(function(){ scanRows(); syncDelivery(); paintFreeFrom(); }, 80);
    // NB: characterData is deliberately NOT observed. This callback WRITES text into the very
    // subtree it watches (syncDelivery sets textContent), so observing text changes creates a
    // feedback loop that can lock the main thread — clicks then appear to do nothing at all.
    }).observe(mount, { childList:true, subtree:true });
  }
  refreshGiftChosen();
  /* A country picked in the delivery sheet moves the free-shipping rung, so the ladder, the
     announcement bar's threshold and every row that reads it are repainted. The sheet fires
     ntf:ship-country on the pick and ntf:ship-state once the new zone has been published; both
     are listened for because the second is what carries the number. */
  /* Only when the ZONE actually changed. publishState() fires at every load and several times per
     pick, and each repaint refetches /cart.js - measured as an extra request at load of a cart
     nothing had changed (review, 25 Sept). The zone is published synchronously at init, so the
     first comparison already holds the right country and the load-time repaint never happens. */
  var paintedZone = (window.NTF_SHIP_STATE && window.NTF_SHIP_STATE.zone) ? window.NTF_SHIP_STATE.zone.iso : null;
  function onShipZone(){
    var z = window.NTF_SHIP_STATE && window.NTF_SHIP_STATE.zone, iso = z ? z.iso : null;
    if (iso === paintedZone) return;
    paintedZone = iso;
    scanRows(); refreshRows(); paintFreeFrom();
  }
  window.addEventListener('ntf:ship-state', onShipZone);
  window.addEventListener('ntf:ship-country', onShipZone);
  document.addEventListener('eurus:cart:items-changed', function(){ scanRows(); refreshRows(); refreshGiftChosen(); });
  document.addEventListener('cart:updated', function(){ scanRows(); refreshRows(); });

  // ---- Product page: "Choose a size" guard --------------------------------------------------
  // The button is a NORMAL add-to-cart. Whether a size is still needed is decided when the
  // customer clicks, because the server-rendered state goes stale the moment they pick one
  // without a page reload — which is exactly what happened before: the label stayed "Choose a
  // size" and the click kept scrolling back to the picker even after choosing.
  (function(){
    function pickerRoot(btn){
      var id = btn.getAttribute("data-ntf-sizeguard");
      return document.getElementById("variant-update-" + id);
    }
    // Nothing chosen = the placeholder <option id="...-blank"> is still selected, or no radio
    // is checked. The placeholder has no value attribute, so select.value is unreliable.
    function needsChoice(root){
      if (!root) return false;
      var sels = root.querySelectorAll("select");
      for (var i = 0; i < sels.length; i++){
        var o = sels[i].selectedOptions && sels[i].selectedOptions[0];
        if (o && /-blank$/.test(o.id || "")) return true;
      }
      var groups = root.querySelectorAll("[data-option-name]");
      for (var j = 0; j < groups.length; j++){
        var inputs = groups[j].querySelectorAll("input[type=radio]");
        if (inputs.length && !groups[j].querySelector("input[type=radio]:checked")) return true;
      }
      return false;
    }
    function relabel(btn){
      var root = pickerRoot(btn);
      var txt = btn.querySelector(".x-atc-text .flex, .x-atc-text");
      if (!txt) return;
      var real = btn.getAttribute("data-ntf-atc-label");
      if (!needsChoice(root)){
        if (real && txt.textContent.trim() !== real) txt.textContent = real;
      } else if (txt.textContent.trim() === real){
        txt.textContent = T('choose-a-size', null, 'Choose a size');
      }
    }
    function scan(){ document.querySelectorAll("[data-ntf-sizeguard]").forEach(relabel); }

    // capture phase, so this runs BEFORE Alpine's @click adds the item
    document.addEventListener("click", function(e){
      var btn = e.target.closest && e.target.closest("[data-ntf-sizeguard]");
      if (!btn) return;
      var root = pickerRoot(btn);
      if (!needsChoice(root)) return;         // a size is chosen — let the theme add to cart
      e.preventDefault();
      e.stopImmediatePropagation();
      var c = root.querySelector("select:not([disabled])") || root.querySelector("[data-option-name]") || root;
      root.classList.add("ntf-size-flash");
      c.scrollIntoView({ behavior:"smooth", block:"center", inline:"center" });
      setTimeout(function(){
        try { if (c.showPicker) c.showPicker(); else if (c.focus) c.focus(); }
        catch(err){ if (c.focus) c.focus(); }
      }, 480);
      setTimeout(function(){ root.classList.remove("ntf-size-flash"); }, 2000);
    }, true);

    document.addEventListener("change", function(e){
      if (e.target.closest && e.target.closest("[id^=variant-update-]")) scan();
    });
    if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", scan);
    else scan();
  })();

})();

/* ---- Drag-to-scroll for the popup's product rails ------------------------------------------
   The rails scroll horizontally, which a phone discovers by swiping and a mouse never discovers at
   all: there is no scrollbar worth grabbing and shift-scroll is not something people try. So the
   rail can be dragged.

   Pointer events, not mouse events, so a trackpad and a pen work the same way. The 4px threshold
   is what separates a drag from a click — without it, letting go over a product opened it. */
(function ntfDragScroll(){
  var SEL = '.cr-recs-track, .cr-side-thumbs, .cr-hero-thumbs';
  var down = null;
  /* The browser's own link drag is cancelled before it starts. CSS handles most of it, but Safari
     and Firefox each ignore a different half of that, so the event is refused as well. */
  document.addEventListener('dragstart', function(e){
    if (e.target.closest && e.target.closest(SEL)) e.preventDefault();
  });
  document.addEventListener('pointerdown', function(e){
    if (e.pointerType === 'touch') return;          // touch already scrolls, natively and better
    var rail = e.target.closest && e.target.closest(SEL);
    if (!rail || rail.scrollWidth <= rail.clientWidth + 1) return;
    down = { rail: rail, x: e.clientX, left: rail.scrollLeft, moved: false, id: e.pointerId };
    /* No capture and no preventDefault on the press itself. Capture retargets everything that
       follows to the capturing element, so the click landed on the rail instead of the ADD button;
       preventDefault suppresses the compatibility mouse events outright. Both are taken later, and
       only for a press that turns into a drag — see pointermove. */
  });
  /* No DOM writes in here. Marking the anchors draggable=false looked harmless and was not: it
     mutates a node inside the container the cart's MutationObserver watches, so every drag
     repainted the recommendations and the rail jumped back to the start. The CSS and the cancelled
     dragstart above already stop the native link drag without touching anything. */
  document.addEventListener('pointermove', function(e){
    if (!down) return;
    var dx = e.clientX - down.x;
    if (!down.moved && Math.abs(dx) < 4) return;
    if (!down.moved){
      down.moved = true;
      down.rail.classList.add('is-dragging');
      down.rail.style.scrollSnapType = 'none';      // snapping mid-drag fights the hand
      down.rail.style.cursor = 'grabbing';
      /* Captured here, not at the press: from this point the gesture is a drag, and the moves have
         to keep arriving even when the cursor leaves the rail. A click never reaches this line. */
      if (down.id != null) { try { down.rail.setPointerCapture(down.id); } catch (err) {} }
    }
    down.rail.scrollLeft = down.left - dx;
    e.preventDefault();
  });
  function end(e){
    if (!down) return;
    if (e && down.id != null) { try { down.rail.releasePointerCapture(down.id); } catch (err) {} }
    var rail = down.rail, moved = down.moved;
    down = null;
    if (!moved) return;
    /* A press that became a drag must not leave anything focused: the browser scrolls a newly
       focused element into view, and after a drag that means scrolling the rail back to where the
       card started. Watched for a moment rather than pre-empted, so an ordinary click keeps its
       focus and its default behaviour. */
    var at = rail.scrollLeft;
    var undoFocus = function(ev){
      if (ev.target && ev.target.blur) ev.target.blur();
      rail.scrollLeft = at;
    };
    rail.addEventListener('focusin', undoFocus, true);
    setTimeout(function(){ rail.removeEventListener('focusin', undoFocus, true); }, 150);
    rail.classList.remove('is-dragging');
    rail.style.cursor = '';
    /* Park on the nearest card FIRST, then hand snapping back. Restoring it while the rail sits
       between two cards makes the browser snap to the nearest snap point — which after a short
       drag is the one you just left, so the rail springs back and the drag looks broken. */
    /* Snapping stays off on a rail that has been dragged, for the rest of the page's life.
       `scroll-snap-type: x mandatory` re-snaps the moment it is restored, and it does not care
       where the rail was parked first — two attempts at aligning to a card exactly, and both times
       it pulled the rail back to the start, which reads as the drag not working at all.
       Touch never gets here (pointerType 'touch' returns above), so swiping keeps its snap. */
    rail.dataset.crFreeScroll = '1';
    /* Swallow the click this drag would otherwise finish with, once. */
    var kill = function(ev){ ev.stopPropagation(); ev.preventDefault(); };
    rail.addEventListener('click', kill, true);
    setTimeout(function(){ rail.removeEventListener('click', kill, true); }, 0);
  }
  document.addEventListener('pointerup', end);
  document.addEventListener('pointercancel', end);
})();

/* ---- Old EasyGift lines (28 Sept 2026) --------------------------------------------------------
   On the previous theme EasyGift auto-added a "Free Gift Box" (_Gifted "€75 tier - gift box") and a
   leather travel case (_Gifted "€275 tier"). It is off on this theme, and its discounts only free those
   lines while its own rules run, so a cart made before the switch would now PAY for them (measured
   28 Sept: €22.50 and €44.10). Here the gift box is included in every order and the €275 reward is
   chosen in the picker, so such lines are removed once, on the first page this cart reaches.
   Only lines with _Gifted and WITHOUT _gift_choice: the picker marks every reward it adds with
   _gift_choice (and also with _Gifted when the campaign has a gift_marker), so a chosen reward is never
   touched. */
(function(){
  var busy = false;
  function purgeOldEasyGift(){
    if (busy) return; busy = true;
    var seen = null;   // the cart as read, when nothing was removed: the gift-line check below starts from it
    fetch('/cart.js', { headers:{ Accept:'application/json' }, cache:'no-store' })
      .then(function(r){ return r.json(); })
      .then(function(cart){
        var updates = {}, n = 0;
        (cart.items || []).forEach(function(it){
          var p = it.properties || {};
          if (p._Gifted && !p._gift_choice){ updates[it.key] = 0; n++; }
        });
        if (!n){ seen = cart; return null; }
        var sectionIds = [];
        try { sectionIds = Alpine.store('xCartHelper').getSectionsToRender().map(function(s){ return s.id; }); } catch(e){}
        return fetch('/cart/update.js', {
          method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
          body: JSON.stringify({ updates: updates, sections: sectionIds })
        }).then(function(r){ return r.json(); })
          .then(function(res){
            var painted = false;
            try { if (res && res.sections){ Alpine.store('xCartHelper').reRenderSections(res.sections); painted = true; } } catch(e){}
            document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
            // The cart page is server-rendered: without re-rendered sections, show the corrected cart.
            if (!painted && /\/cart\/?$/.test(location.pathname)) location.reload();
          });
      })
      .catch(function(){})
      .then(function(){
        busy = false;
        document.dispatchEvent(new CustomEvent('ntf:gift-lines-purged', { detail:{ cart: seen } }));
      });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', purgeOldEasyGift);
  else purgeOldEasyGift();
})();

/* ---- Gift products that reach the cart without the picker (29 Sept 2026) ------------------------
   The €275 reward's gift products (free-gift and the travel case, wallet and mug twins) exist only to
   be given away, and the FREE GIFT discount frees one of them whatever the line carries: a discount
   cannot read line properties. The picker marks every reward it adds (_gift_choice, and the campaign's
   gift_marker as _Gifted), and the rest goes by that mark: the drawer's reward line, the tier check that
   takes the reward out when the cart drops below the tier, IAN. A copy that came in any other way (the
   gift's own product page sold it before this change; NTF50825) had no mark, so it stayed in a cart that no
   longer qualified and was charged at full price. Those pages sell nothing now; this catches what is left,
   an older cart or a hand-made /cart/add, one line per pass:
     - the campaign's limit is already taken by a marked reward -> the unmarked copy is removed;
     - otherwise it BECOMES the reward: the picker's two marks, quantity 1, its other properties kept.
       The picker's own tier check then keeps it (FREE GIFT frees it) or, below the tier, takes it out.
   Which products, which marker and which limit all come from the picker's payload (#gcp-modal[data-gc]:
   giftProductIds, marker, limit — snippets/ntf-gift-products.liquid), so no product, text or number is
   written here. Never any other line: not a line of another product, not an _auto_gift line (the picker's
   reconcile owns those), not an _Gifted-only line (the purge above owns those). Runs once the purge has
   settled, then after every cart change the theme announces. Writes no text. */
(function(){
  var busy = false, again = false, writes = 0, timer = null;
  function payload(){
    var m = document.getElementById('gcp-modal');
    if (!m) return null;
    try { return JSON.parse(m.getAttribute('data-gc') || 'null'); } catch(e){ return null; }
  }
  function pass(snapshot){
    var d = payload();
    var ids = (d && d.giftProductIds) || [];
    if (!ids.length || writes >= 10) return Promise.resolve(false);
    var gift = {};
    ids.forEach(function(id){ gift[String(id)] = true; });
    var read = snapshot ? Promise.resolve(snapshot)
      : fetch('/cart.js', { headers:{ Accept:'application/json' }, cache:'no-store' }).then(function(r){ return r.json(); });
    return read.then(function(cart){
      var chosen = 0, loose = null, over = null, limit = d.limit || 1;
      (cart.items || []).forEach(function(it){
        var p = it.properties || {};
        if (p._gift_choice){
          chosen += it.quantity;
          // A marked gift-product line that is charged is the first to go if the limit is exceeded (below).
          if (gift[String(it.product_id)] && (!over || (it.final_line_price > 0 && !(over.final_line_price > 0)))) over = it;
          return;
        }
        if (!loose && gift[String(it.product_id)] && !p._auto_gift && !p._Gifted) loose = it;
      });
      var body;
      if (!loose){
        // The cart lists ONE line as two when a discount frees part of it (quantity 3 = 2 paid + 1 free), and
        // marking one part marks a unit of the other too. More marked gifts than the campaign allows: trim.
        if (!over || chosen <= limit) return false;
        body = { id: String(over.key), quantity: Math.max(0, over.quantity - (chosen - limit)) };
      } else if (chosen >= limit){
        body = { id: String(loose.key), quantity: 0 };
      } else {
        var props = {}, lp = loose.properties || {};
        for (var k in lp){ if (Object.prototype.hasOwnProperty.call(lp, k)) props[k] = lp[k]; }
        props._gift_choice = 'true';
        if (d.marker) props._Gifted = d.marker;
        body = { id: String(loose.key), quantity: 1, properties: props };
      }
      var sectionIds = [];
      try { sectionIds = Alpine.store('xCartHelper').getSectionsToRender().map(function(s){ return s.id; }); } catch(e){}
      body.sections = sectionIds;
      writes++;
      if (window.console) console.info('[gift choice] a gift product line without the picker\'s mark was ' + (body.quantity ? 'marked' : 'removed'));
      return fetch('/cart/change.js', {
        method:'POST', headers:{ 'Content-Type':'application/json', Accept:'application/json' },
        body: JSON.stringify(body)
      }).then(function(r){
        // A key that changed under us (a discount re-hashes keys) or a refused quantity: look again.
        if (!r.ok) return true;
        return r.json().then(function(res){
          var painted = false;
          try { if (res && res.sections){ Alpine.store('xCartHelper').reRenderSections(res.sections); painted = true; } } catch(e){}
          document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
          // The cart page is server-rendered: without re-rendered sections, show the corrected cart.
          if (!painted && /\/cart\/?$/.test(location.pathname)) location.reload();
          return true;
        });
      });
    }).catch(function(){ return false; });
  }
  function run(snapshot){
    if (busy){ again = true; return; }
    busy = true; again = false;
    pass(snapshot).then(function(wrote){
      busy = false;
      if (wrote || again) schedule();   // one line per pass; the next on a fresh cart
    });
  }
  function schedule(){ clearTimeout(timer); timer = setTimeout(function(){ run(null); }, 250); }
  document.addEventListener('ntf:gift-lines-purged', function(e){
    clearTimeout(timer);
    run(e && e.detail && e.detail.cart);
  });
  document.addEventListener('eurus:cart:items-changed', schedule);
})();

/* Phone menu: the room the country and language lists may take, and the country list opening at the
   visitor's own country (Kai, 28 Sept: "the dropdown on the currency and on the Language are bad ...
   It does barely scroll"). The lists open upward over the menu (assets/ntf-cart.css, .ntf-mnav-loc);
   their cap is the space between the menu's top edge and the row, which depends on the menu, the
   login state and how far the menu is scrolled - so it is measured at the tap, in the capture phase,
   before Alpine shows the list. The country list is fetched on its first opening; the theme marks the
   current country with .effect-inline, and it is scrolled to the middle once it is there. */
(function(){
  document.addEventListener('click', function(e){
    var btn = e.target && e.target.closest && e.target.closest('.ntf-mnav-loc button');
    if (!btn) return;
    var row = btn.closest('.ntf-mnav-loc');
    // the menu's scroll box (#menu-navigation today): the nearest ancestor that scrolls
    var menu = row.parentElement;
    while (menu && menu !== document.body && !/(auto|scroll)/.test(getComputedStyle(menu).overflowY)) menu = menu.parentElement;
    var edge = (menu && menu !== document.body) ? Math.max(0, menu.getBoundingClientRect().top) : 0;
    var room = row.getBoundingClientRect().top - edge - 8;
    row.style.setProperty('--ntf-loc-room', Math.max(160, Math.round(room)) + 'px');
    var list = btn.parentElement.querySelector('.country-options');
    if (!list) return;
    var tries = 0;
    (function centre(){
      var cur = list.querySelector('a.effect-inline');
      if (cur && list.offsetParent && list.clientHeight){
        var li = cur.closest('li') || cur;
        list.scrollTop = Math.max(0, li.offsetTop - (list.clientHeight - li.offsetHeight) / 2);
        return;
      }
      if (++tries < 80) setTimeout(centre, 50);   // the list arrives by fetch on its first opening
    })();
  }, true);
})();
